import * as React from "react";
import * as ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { variables } from '../Variables';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import { Schedular } from './Schedular';
import { Dropdown, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { MultiSelect } from "react-multi-select-component";
import { setstatusfilter, clearstatusfilter } from "../features/StatusFilterSlice";
import { setagentfilter, clearagentfilter } from "../features/AgentFilterSlice";
import { setselectedproperty, clearselectedproperty } from "../features/SelectedPropertySlice";
import { setsetting, clearsetting } from "../features/SettingSlice";
import { setSidebarCollapsed } from "../features/SidebarCollapseSlice";
import { setlanguages, resetlanguages } from "../features/LanguageSlice";
import { EventModal } from "./EventModal";
import { ConfirmDeleteWindow } from "./ConfirmDeleteWindow";
import { setCalendarView } from "../features/CalendarSelectedViewSlice";
import { cleareventdetail } from "../features/CreateEventDetailSlice";
import { clearBookAbleUntil } from "../features/BookAbleUntilSlice";
import { login } from "../features/userSlice";

import filterIcon from '../assets/images/filter-icon.svg';
import plusIcon from '../assets/images/plus.svg';
import deleteIcon from '../assets/images/trash-white.svg';
import collapseIcon from '../assets/images/collapse.svg';
import expandIcon from '../assets/images/expand.svg';
import logOutIcon from '../assets/images/log-out.svg';
import placeholderLarge from '../assets/images/prop-placeholder-lg.jpg';
import placeholderSmall from '../assets/images/prop-placeholder-sm.jpg';
import plusBlueIcon from '../assets/images/plus_blue.svg';
import locationPin from '../assets/images/location-pin.svg';
import bedIcon from '../assets/images/bed-duo.svg';
import showerIcon from '../assets/images/shower-duo.svg';
import liftIcon from '../assets/images/lift-duo.svg';
import clearCross from '../assets/images/clear-filter-cross.svg';
import whiteCross from '../assets/images/cross_white.png';
import filterCross from '../assets/images/filter-cross.svg';
import calLoader from '../assets/images/calendar-loader.svg';
import { clearDuplicateTimeSlots } from "../features/DuplicateTimeSlotSlice";
import { clearScheduleTimeSlotDetail } from "../features/ScheduleTimeSlotDetailSlice";

const { useState, useRef, useCallback } = React;

export const Calendar = ({ showMessage }) => {
    const user = useSelector(state => state.user.user);
    const [selected, setSelected] = useState([]);
    const [isPropertiesCollapsed, setIsPropertiesCollapsed] = useState(false);
    const [clientEstates, setClientEstates] = useState([]);
    const [filteredEstates, setFilteredEstates] = useState([]);
    const [clientToken, setClientToken] = useState('');
    const [height, setHeight] = useState(null);
    const [showHideCalendarFilter, setShowHideCalendarFilter] = useState(false);
    const [whiseAgents, setWhiseAgents] = useState([]);
    const [whiseCalendarEvents, setWhiseCalendarEvents] = useState([]);
    const [calendarEventsFromDB, setCalendarEventsFromDB] = useState([]);
    const [whiseCalendarEventId, setWhiseCalendarEventId] = useState(0);
    const [whiseContactId, setWhiseContactId] = useState(0);
    const [showModal, setShowModal] = useState(false);
    //const [officeId, setOfficeId] = useState(user.user.officeId);
    const [confirmedIds, setConfirmedIds] = useState([]);
    const [tobeConfirmedIds, setTobeConfirmedIds] = useState([]);
    const [freeSlotIds, setFreeSlotIds] = useState([]);
    const [calendarActions, setCalendarActions] = useState([]);
    const [officeSettings, setOfficeSettings] = useState({});
    const [selectedProperty, setSelectedProperty] = useState(null);
    const [selectedAgents, setSelectedAgents] = useState([]);
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [previewEvent, setPreviewEvent] = useState(false);
    const [showCalendarLoader, setShowCalendarLoader] = useState(true);
    const [estateId, setEstateId] = useState("");
    const [estateSearch, setEstateSearch] = useState("");
    const [purposeStatusId, setPurposeStatusId] = useState("2");
    /* const [displayStatusId, setDisplayStatusId] = useState([]);*/
    const [estateListContainEvent, setEstateListContainEvent] = useState([]);
    const [estateIdsHavingFreeSlotsInFutureOrPast, setEstateIdsHavingFreeSlotsInFutureOrPast] = useState([]);
    const [previewEventDetail, setPreviewEventDetail] = useState(null);
    const [eventToBeAccepted, setEventToBeAccepted] = useState(null);
    const [estateDetailForEventToBeAccepted, setEstateDetailForEventToBeAccepted] = useState(null);
    const [whiseOffice, setWhiseOffice] = useState(null);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [showConfirmWindow, setShowConfirmWindow] = useState(false);
    const [isDeleteConfirmed, setIsDeleteConfirmed] = useState(false);
    const [freeSlotsEstateIdToBeDeleted, setFreeSlotsEstateIdToBeDeleted] = useState(null);
    const [clickedDeleteFreeSlotButton, setClickedDeleteFreeSlotButton] = useState(null);
    const [estateIdsHavingConfiguration, setEstateIdsHavingConfiguration] = useState([]);
    const [confirmWindowMessage, setConfirmWindowMessage] = useState("Do you want to delete past free slots?");
    const [isLocalDbEventToBeDeleted, setIsLocalDbEventToBeDeleted] = useState(false);
    const [currentRange, setCurrentRange] = useState({ start: null, end: null });
    const [activatedEstates, setActivatedEstates] = useState([]);
    const [suspendedEstates, setSuspendedEstates] = useState([]);
    const [showSynchingLoader, setShowSynchingLoader] = useState(false);
    const estateDropdownManuRef = useRef(null);

    const [isEstateConfigurationsEdit, setIsEstateConfigurationsEdit] = useState(false);
    const [showPropertiesLoader, setShowPropertiesLoader] = useState(false);
    const [selectOffice, setSelectOffice] = useState("");
    const [isOfficesLoaded, setIsOfficesLoaded] = useState(false);
    const [officeList, setOfficeList] = useState([]);

    const clientId = user.user.clientId;
    const officeId = user.user.officeId;
    const contactId = user.user.contactId;
    const whiseUserToken = useSelector(state => state.whiseUser.whiseToken);
    const reduxProperty = useSelector(state => state.selectedProperty.selectedProperty);
    const reduxStatus = useSelector(state => state.statusFilter.statusFilter);
    const reduxAgent = useSelector(state => state.agentFilter.agentFilter);
    const reduxEventDetail = useSelector(state => state.eventDetail.eventDetail);
    const actions = useSelector(state => state.calendarActions.calendarActions);
    const reduxClientToken = useSelector(state => state.whiseClientToken.whiseClientToken);
    const reduxIsSidebarCollapsed = useSelector(state => state.isSideBarCollapsed.sidebarCollapsed);
    /*console.log(reduxEventDetail);*/
    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);
    const reduxSelectedLanguage = useSelector(state => state.selectedLanguageTranslations.selectedLanguage);
    const reduxCalendarView = useSelector(state => state.calendarView.calendarView);
    const reduxBookAbleUntil = useSelector(state => state.bookAbleUntil.bookAbleUntil);
    /*let statusesOptions =;*/
    const customMultiSelectLabels = {
        "allItemsAreSelected": reduxLanguageTranslations ? reduxLanguageTranslations["multiSelectDropdownAllItemsSelectLbl"] : "All items are selected.",
        "noOptions": reduxLanguageTranslations ? reduxLanguageTranslations["multiSelectDropdownNoOptionsLbl"] : "No options",
        "search": reduxLanguageTranslations ? reduxLanguageTranslations["multiSelectDropdownSearchLbl"] : "Search",
        "selectAll": reduxLanguageTranslations ? reduxLanguageTranslations["multiSelectDropdownSelectAllLbl"] : "Select All",
        "selectAllFiltered": reduxLanguageTranslations ? reduxLanguageTranslations["multiSelectDropdownSelectAllFilterLbl"] : "Select All (Filtered)",
        "selectSomeItems": reduxLanguageTranslations ? reduxLanguageTranslations["multiSelectDropdownSelectLbl"] : "Select..."
    }

    const displayStatusOptions = [
        { label: reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterDisplayStatusOffline"] : "Offline", value: "1" },
        { label: reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterDisplayStatusOnline"] : "Online", value: "2" },
        { label: reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterDisplayStatusMonth"] : "EstateOfTheMonth", value: "3" },
        { label: reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterDisplayStatusRealisations"] : "Realisations", value: "4" },
        { label: reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterDisplayStatusWebsite"] : "OnlineWebsiteOnly", value: "5" },
    ];

    const [displayStatusIds, setDisplayStatusIds] = useState([
        displayStatusOptions[0], // Offline
        displayStatusOptions[1], // Online
        displayStatusOptions[2], // EstateOfTheMonth
    ]);

    let container = useRef(null);
    const calendarRef = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleClose = () => {
        setShowModal(false);
        dispatch(cleareventdetail());
        dispatch(clearBookAbleUntil());
        dispatch(clearDuplicateTimeSlots());
        dispatch(clearScheduleTimeSlotDetail());
        setTimeout(() => {
            setPreviewEvent(false);
            setIsEstateConfigurationsEdit(false);
        }, 200)
    }

    const handlerSaveFilter = (e) => {

        dispatch(setselectedproperty(selectedProperty));
        dispatch(setagentfilter(selectedAgents));
        dispatch(setstatusfilter(selectedStatuses));
        setShowHideCalendarFilter(false);

        //let filterObj = {
        //    "OfficeId": +officeId,
        //    "clientId": +clientId,
        //    "userId": user.user.userId,
        //    "propertyId": reduxProperty.id,
        //    "agentIds": null,
        //    "freeSlotStatusIds": null,
        //    "toBeConfirmedStatusIds": null,
        //    "confirmedStatusIds": null,
        //}

        //if (reduxAgent != null && reduxAgent.length > 0) {
        //    let agentids = "";
        //    let lengthOfAgents = reduxAgent.length;

        //    reduxAgent.map((item, i) => {
        //        if (i == 0) {
        //            agentids += item.value
        //        }
        //        else {
        //            agentids += ", " + item.value
        //        }
        //    })
        //    filterObj["agentIds"] = agentids;
        //}
        //if (reduxStatus !== undefined && reduxStatus !== null && reduxStatus.length > 0) {
        //    reduxStatus.map(item => {
        //        let calendarActionIds = "";
        //        if (item.value === "1") {
        //            calendarActionIds += item._freeSlotIds[0] + "," + item._freeSlotIds[1];
        //            //calendarActionIds.push(item._freeSlotIds[1]);
        //            filterObj["freeSlotStatusIds"] = calendarActionIds
        //        }
        //        else if (item.value === "2") {
        //            calendarActionIds += item.beforeConfirmationIds[0] + "," + item.beforeConfirmationIds[1];
        //            //calendarActionIds.push(item.beforeConfirmationIds[1]);
        //            filterObj["toBeConfirmedStatusIds"] = calendarActionIds
        //        }
        //        else {
        //            calendarActionIds += item.afterConfirmationIds[0] + "," + item.afterConfirmationIds[1];
        //            //calendarActionIds.push(item.afterConfirmationIds[1]);
        //            filterObj["confirmedStatusIds"] = calendarActionIds
        //        }
        //    })
        //}

        //let url = variables.API_URL + `Filter/SaveFilter?`;

        //const jsonconfig = {
        //    headers: {
        //        'Authorization': `Bearer ${user.tokenValue}`,
        //        'Content-Type': 'application/json'
        //    }
        //};
        //axios.post(url, JSON.stringify(filterObj), jsonconfig) // ASP.NET Core API endpoint with header
        //    .then(response => {
        //        if (response.status == 200) {
        //            showMessage("success", response.data);
        //        }
        //    })
        //    .catch(error => {
        //        console.error('Error fetching data:', error);
        //        e.target.removeAttribute("disabled");
        //        document.querySelector("body").style.cursor = "";
        //    });
    }

    const handleCancelFilter = () => {
        setShowHideCalendarFilter(false);
    }

    const getSavedFilterData = () => {
        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };
        const url = variables.API_URL + `Filter/GetFilter?officeId=` + officeId;
        axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                var filter = response.data;
                if (filter) {
                    //set saved agents filter to agents redux store
                    if (filter.agentIds != null) {
                        let agentIdsInString = filter.agentIds.split(",")
                        let agentIds = agentIdsInString.map(item => { return +item });
                        let filteredAgents = [];
                        whiseAgents.forEach(el => {
                            if (agentIds.indexOf(el.id) !== -1) {
                                filteredAgents.push({ label: el.name, value: el.id, agentDetail: el });
                            }
                        });
                        dispatch(setagentfilter(filteredAgents));
                    }

                    //set saved status filter to status redux store
                    let selectedStatuses = [];
                    if (filter.confirmedStatusIds != null) {
                        selectedStatuses.push({ label: "Confirmed", value: "3", afterConfirmationIds: confirmedIds });
                    }

                    if (filter.toBeConfirmedStatusIds != null) {
                        selectedStatuses.push({ label: "To be Confirmed", value: "2", beforeConfirmationIds: tobeConfirmedIds });
                    }

                    if (filter.freeSlotStatusIds != null) {
                        selectedStatuses.push({ label: "Free Slot", value: "1", _freeSlotIds: freeSlotIds });
                    }
                    dispatch(setstatusfilter(selectedStatuses));

                    let selectedEstate = clientEstates.filter(item => {
                        return item.id == filter.propertyId
                    })
                    setSelectedProperty(current => selectedEstate[0]);
                    dispatch(setselectedproperty(selectedEstate[0]));
                }
                else {
                    setSelectedProperty(current => clientEstates[0]);
                    dispatch(setselectedproperty(clientEstates[0]));
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const changeHandlerAgentFilter = (e) => {
        let option = e.target.selectedOptions;
        if (option[0].value != "") {
            let item = JSON.parse(option[0].dataset.agent);
            let agent = [{ label: item.name, value: item.id, agentDetail: item }];
            setSelectedAgents(agent);
        }
        else {
            setSelectedAgents([]);
        }
        //dispatch(setagentfilter(e));
    }

    const callBackToUpdateCalendarFilter = (agent) => {
        if (agent.length > 0) {
            setSelectedAgents(agent);
        }
        else {
            setSelectedAgents([]);
        }
    }

    const handlerClearCalenderFilter = (e) => {
        e.stopPropagation();
        setSelectedStatuses([]);
        setSelectedAgents([]);
        dispatch(clearstatusfilter());
        dispatch(clearagentfilter());
    }

    const handleChangeStatus = (item) => {
        setSelectedStatuses(item)
        //dispatch(setstatusfilter(item));
    }

    const getClientWhiseEstatesList = async (clientToken) => {
        var estateLimit = 300;
        var pageOffset = 0;
        let listOfEstates = [];

        let _response = await getWhiseEstatesListByPagin(clientToken, estateLimit, pageOffset);
        if (_response.totalCount != undefined && _response.totalCount > 300) {
            listOfEstates.push(..._response.estates);
            let _afterDivison = _response.totalCount / 300;
            let pages = Math.ceil(_afterDivison);
            for (let i = 1; i < pages; i++) {
                pageOffset = estateLimit * i + 1;
                let _getEstateListResponse = await getWhiseEstatesListByPagin(clientToken, estateLimit, pageOffset);
                if (_getEstateListResponse.estates.length > 0) {
                    listOfEstates.push(..._getEstateListResponse.estates);
                }
            }

            const modifyDisplayStausSelectedIds = displayStatusIds.map((item) => +item.value); // [1,2,3]
            let estatesAfterApplyingFilter = listOfEstates.filter(item => {
                return (
                    item.officeId == +selectOffice
                );
            });

            if (estateSearch != "") {
                let listAfterFirstFilter = estatesAfterApplyingFilter.filter(item => {
                    let itemPrice = item.price != undefined ? item.price + "" : "";
                    let city = item.city != undefined ? item.city.toLowerCase() : "";
                    let address = item.address != undefined ? item.address.toLowerCase() : "";
                    let zip = item.zip != undefined ? item.zip.toLowerCase() : "";
                    let number = item.number != undefined ? item.number.toLowerCase() : "";
                    return city.includes(estateSearch) || address.includes(estateSearch) || itemPrice.includes(estateSearch) || zip.includes(estateSearch) || number.includes(estateSearch);
                });
                estatesAfterApplyingFilter = listAfterFirstFilter;
            }
            if (estateId != "") {
                let listAfterSecondFilter = estatesAfterApplyingFilter.filter(item => {
                    let itemEstateId = item.id + "";
                    return itemEstateId.includes(estateId);
                });
                estatesAfterApplyingFilter = listAfterSecondFilter;
            }
            if (modifyDisplayStausSelectedIds.length > 0) {
                let listAfterThirdFilter = estatesAfterApplyingFilter.filter(item =>
                    modifyDisplayStausSelectedIds.includes(item.displayStatusId)
                );
                estatesAfterApplyingFilter = listAfterThirdFilter;
            }
            if (purposeStatusId != "") {
                let filteredEstatesList = estatesAfterApplyingFilter.filter(item => {
                    return item.purpose.id == purposeStatusId;
                })
                setFilteredEstates(filteredEstatesList);
                estatesAfterApplyingFilter = filteredEstatesList;
            }

            if (listOfEstates.length > 0) {
                setClientEstates(listOfEstates);
                setFilteredEstates(estatesAfterApplyingFilter);
            }
        }
        else if (_response.estates != undefined && _response.estates.length > 0) {
            listOfEstates.push(..._response.estates);

            const modifyDisplayStausSelectedIds = displayStatusIds.map((item) => +item.value); // [1,2,3]
            let estatesAfterApplyingFilter = listOfEstates.filter(item => {
                return (
                    item.officeId == +selectOffice
                );
            });

            if (estateSearch != "") {
                let listAfterFirstFilter = estatesAfterApplyingFilter.filter(item => {
                    let itemPrice = item.price != undefined ? item.price + "" : "";
                    let city = item.city != undefined ? item.city.toLowerCase() : "";
                    let address = item.address != undefined ? item.address.toLowerCase() : "";
                    let zip = item.zip != undefined ? item.zip.toLowerCase() : "";
                    let number = item.number != undefined ? item.number.toLowerCase() : "";
                    return city.includes(estateSearch) || address.includes(estateSearch) || itemPrice.includes(estateSearch) || zip.includes(estateSearch) || number.includes(estateSearch);
                });
                estatesAfterApplyingFilter = listAfterFirstFilter;
            }
            if (estateId != "") {
                let listAfterSecondFilter = estatesAfterApplyingFilter.filter(item => {
                    let itemEstateId = item.id + "";
                    return itemEstateId.includes(estateId);
                });
                estatesAfterApplyingFilter = listAfterSecondFilter;
            }
            if (modifyDisplayStausSelectedIds.length > 0) {
                let listAfterThirdFilter = estatesAfterApplyingFilter.filter(item =>
                    modifyDisplayStausSelectedIds.includes(item.displayStatusId)
                );
                estatesAfterApplyingFilter = listAfterThirdFilter;
            }
            if (purposeStatusId != "") {
                let filteredEstatesList = estatesAfterApplyingFilter.filter(item => {
                    return item.purpose.id == purposeStatusId;
                })
                setFilteredEstates(filteredEstatesList);
                estatesAfterApplyingFilter = filteredEstatesList;
            }

            setClientEstates(listOfEstates);
            setFilteredEstates(estatesAfterApplyingFilter);
        }
    }

    const getWhiseEstatesListByPagin = async (clientToken, estateLimit, pageOffset) => {
        let url = "https://api.whise.eu/v1/estates/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };
        let response = await axios.post(url, {
            "Filter": {
                "StatusIds": [1],
                "PurposeStatusIds": [1, 2, 5, 6, 10, 11, 12, 13, 15, 16, 20, 21, 27, 28],
                "DisplayStatusIds": [1, 2, 3, 4, 5],
                "LanguageId": reduxSelectedLanguage ? reduxSelectedLanguage : null
            },
            "Page": {
                "Limit": estateLimit,
                "Offset": pageOffset
            },
            "Sort": [
                { "Field": "updateDateTime", "Ascending": false }
            ]
        }, config)

        return response.data;
    }

    const checkFreeSlotsExistForEstateOnWhise = async (estateId, _clientToken) => {
        if (_clientToken && freeSlotIds.length > 0) {
            let url = "https://api.whise.eu/v1/calendars/list";
            const config = {
                headers: {
                    'Authorization': `Bearer ${_clientToken}`,
                    'Content-Type': 'application/json'
                },
            };
            let body = {
                "Filter": {
                    "CalendarActionIds": freeSlotIds,
                    "EstateIds": [estateId]
                }
            };
            let response = await axios.post(url, body, config);

            if (response.data.totalCount != undefined && response.data.totalCount > 0) {
                return true;
            }
            else {
                return false;
            }
        }
        return false;
    }

    const checkFreeSlotsExistForEstateInDB = async (estateId) => {
        if (clientId && freeSlotIds.length > 0) {
            let url = variables.API_URL + `LocalEvents/CheckFreeSlotsExistsAgainstEstate?clientId=${clientId}&estateId=${estateId}&actionIds=${freeSlotIds}`;
            const config = {
                headers: {
                    'Authorization': `Bearer ${user.tokenValue}`,
                    'Content-Type': 'application/json'
                },
            };
            let response = await axios.post(url, {}, config);

            if (response.data.totalCount != undefined && response.data.totalCount > 0) {
                return true;
            }
            else {
                return false;
            }
        }
        return false;
    }

    const getEstateIdsHavingConfigSaved = async () => {
        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };
        const url = variables.API_URL + `Calendar/GetEstateIdsSavedInConfigurations?clientId=${user.user.clientId}`;

        await axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                let _esateIdsHavingConfigs = response.data;
                if (_esateIdsHavingConfigs != null) {
                    setEstateIdsHavingConfiguration(_esateIdsHavingConfigs);
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });

    }

    const handlerCollapseProperties = () => {
        if (isPropertiesCollapsed == true) {
            setIsPropertiesCollapsed(false);
        }
        else {
            setIsPropertiesCollapsed(true);
        }
        setOpenDropdownId(null);
    }

    const handlerPropertyClick = (property) => {
        //let element = e.target;
        //element.classList.add("selected");
        let currentProp = property;

        setSelectedProperty(current => currentProp);
        dispatch(setselectedproperty(currentProp));
        setOpenDropdownId(null);
    }

    const showCalendarFilters = (e) => {
        if (showHideCalendarFilter == true) {
            setShowHideCalendarFilter(false);
        }
        else {
            setShowHideCalendarFilter(true);
        }
    }

    const getAgents = async (clientToken) => {
        let url = "https://api.whise.eu/v1/admin/representatives/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };

        axios.post(url, {}, config)
            .then(response => {
                setWhiseAgents(response.data.representatives);
            })
            .catch(error => {
                showMessage("error", error);
            });
    }

    const handlerAddSlot = () => {
        dispatch(cleareventdetail());
        setShowModal(true);
    }

    /////////////////////4/8/2024//////////////
    const getOfficeSettings = () => {
        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };
        const url = variables.API_URL + `Settings/GetSetting?officeId=` + officeId;
        axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                let settings = response.data;
                //console.log(settings);
                if (response.data != null) {
                    setOfficeSettings(response.data);
                    dispatch(setsetting(response.data));

                    let toBeConfirmed = [settings.visitToSaleBefore, settings.visitToRentBefore];
                    let cofirmed = [settings.visitToSaleAfter, settings.visitToRentAfter];
                    let freeslot = [settings.visitToSaleFreeSlot, settings.visitToRentFreeSlot];

                    setTobeConfirmedIds(toBeConfirmed);
                    setConfirmedIds(cofirmed);
                    setFreeSlotIds(freeslot);

                    if (settings.officesDetail == "" || settings.officesDetail == null) {
                        getWhiseOffices();
                    } else {
                        let _officesDetail = JSON.parse(settings.officesDetail);
                        if (_officesDetail.length > 0) {
                            setOfficeList(_officesDetail);
                            setSelectOffice(_officesDetail[0].Id);
                            let _filteredOffice = _officesDetail.filter((item) => { return item.Id == officeId });
                            setWhiseOffice(_filteredOffice[0]);
                            //setIsOfficesLoaded(true);
                        }
                        else {
                            getWhiseOffices();
                        }
                    }
                }
                else {
                    //window.location.href = "/settings";
                    navigate("/settings");
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }
    // Function to handle accept action

    const acceptAction = () => {
        // Your accept action code here
    }

    // Function to handle refuse action
    const refuseAction = () => {
        // Your refuse action code here
    }

    const getAction = (actionId) => {
        let action = calendarActions.filter((d) => d.id === +actionId);
        return action[0].name;
    }

    const sendEmail = (body) => {
        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };
        let subject = "api_testing_1";
        let html = "<p>A " + getAction(reduxEventDetail.event.EventType) + " request has been booked through smartcalendar online visit planner for:</p>";

        html += "<h5>Contacts</h5>";
        html += "<p>" + reduxEventDetail.invitee.Name + "</p>";
        html += "<p>" + reduxEventDetail.invitee.Email + "</p>";
        html += "<h5>Property</h5>";
        html += "<p>" + reduxProperty.name + "</p>";
        html += "<h5>Date</h5>";
        html += "<p>" + body.StartDateTime + "</p>";
        html += "<button onclick='acceptAction()'>Accept</button>";
        html += "<button onclick='refuseAction()'>Refuse</button>";
        let sendTo = "umarfarooq3540@gmail.com";
        const url = variables.API_URL + `Email/SendEmail?sendEmailTo=${sendTo}&body=${html}&subject=${subject}`;
        axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                var resp = response.data;

            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    function toLocalISOString(date) {
        const offsetInMinutes = date.getTimezoneOffset();
        const adjustedDate = new Date(date.getTime() - offsetInMinutes * 60 * 1000);
        return adjustedDate.toISOString().slice(0, 19); // Remove milliseconds and 'Z'
    }

    const getWhiseCalenderEvents = async (callingFrom, _startDate, _endDate, view) => {
        let currentView = view || (reduxCalendarView ? reduxCalendarView.view : "timeGridWeek");
        let startDate, endDate;

        // Convert _startDate and _endDate to Date objects if they are strings
        if (_startDate) _startDate = new Date(_startDate);
        if (_endDate) _endDate = new Date(_endDate);

        // Determine the date range
        if (!_startDate || !_endDate) {
            ({ startDate, endDate } = getDateRangeForView(currentView));
        } else {
            startDate = toLocalISOString(_startDate);
            endDate = toLocalISOString(_endDate);
        }

        setCurrentRange({ start: startDate, end: endDate });
        dispatch(setCalendarView({ startDate, endDate, view: currentView }));

        let savedCalendarActions = [...new Set([...freeSlotIds, ...tobeConfirmedIds, ...confirmedIds])];
        let estateEvents = selectedProperty ?
            await getWhiseCalendarEventsForSelectedEstate(startDate, endDate, selectedProperty.id, savedCalendarActions) : [];

        let agentEvents = selectedAgents.length > 0 ?
            await getWhiseCalendarEventsForSelectedAgent(startDate, endDate, selectedAgents[0].agentDetail.id) : [];

        // Remove deduplicate events
        let uniqueEvents = [...new Map([...agentEvents, ...estateEvents].map(event => [event.id, event])).values()];

        setWhiseCalendarEvents(uniqueEvents);
        if (user && user.user.firstSynchronization) {
            setShowCalendarLoader(false);
        }
    };

    // Helper function to get the date range based on the current view
    const getDateRangeForView = (view) => {
        let date = new Date();
        let startDate, endDate;

        if (view === "timeGridDay") {
            // Set to current day 12:00 AM to 11:59:59 PM
            date.setHours(0, 0, 0, 0);
            startDate = date;
            date.setHours(23, 59, 59, 999);
            endDate = date;
        } else if (view === "dayGridMonth") {
            // Set to first and last date showing in the month view grid
            let firstDayShowing = new Date(date.getFullYear(), date.getMonth(), 1);
            firstDayShowing.setDate(firstDayShowing.getDate() - firstDayShowing.getDay()); // Adjust to Sunday of the first week shown
            firstDayShowing.setHours(0, 0, 0, 0);

            let lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            let lastDayShowing = new Date(lastDayOfMonth);
            lastDayShowing.setDate(lastDayOfMonth.getDate() + (6 - lastDayOfMonth.getDay()));
            lastDayShowing.setHours(23, 59, 59, 999);

            startDate = firstDayShowing;
            endDate = lastDayShowing;
        } else {
            // Default to week view
            let firstDayOfWeek = new Date(date);
            firstDayOfWeek.setDate(date.getDate() - ((date.getDay() + 6) % 7));
            firstDayOfWeek.setHours(0, 0, 0, 0);

            let lastDayOfWeek = new Date(firstDayOfWeek);
            lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);
            lastDayOfWeek.setHours(23, 59, 59, 999);

            startDate = firstDayOfWeek;
            endDate = lastDayOfWeek;
        }

        return { startDate: toLocalISOString(startDate), endDate: toLocalISOString(endDate) };
    };


    //Fetch events for selected estate from whise and DB
    const getWhiseCalendarEventsForSelectedEstate = async (startDate, endDate, estateId, calendarActions) => {
        var eventLimit = 300;
        var pageOffset = 0;
        let listOfEvents = [];

        let _response = await getWhiseCalendarEventsByPagination(eventLimit, pageOffset, startDate, endDate, "estate", estateId, calendarActions);

        //get free slots saved in Database only when Synchronization on Whise is disabled
        if (officeSettings.syncEventsToWhise == false) {
            let responseLocalDBEvents = await getCalendarEventsFromDB(startDate, endDate, "estate", estateId, calendarActions);
            if (responseLocalDBEvents.totalCount != undefined && responseLocalDBEvents.totalCount > 0) {
                listOfEvents.push(...responseLocalDBEvents.calendars);
            }
        }

        if (_response.totalCount != undefined && _response.totalCount > 300) {
            listOfEvents.push(..._response.calendars);
            let _afterDivison = _response.totalCount / 300;
            let pages = Math.ceil(_afterDivison);
            for (let i = 1; i < pages; i++) {
                pageOffset = eventLimit * i + 1;
                let _eventResponse = await getWhiseCalendarEventsByPagination(eventLimit, pageOffset, startDate, endDate, "estate", estateId, calendarActions);
                if (_eventResponse.calendars != undefined && _eventResponse.calendars.length > 0) {
                    listOfEvents.push(..._eventResponse.calendars);
                }
            }
        }
        else if (_response.calendars != undefined && _response.calendars.length > 0) {
            listOfEvents.push(..._response.calendars);
        }

        return listOfEvents;
    }

    //Fetch events for selected agent from whise and DB
    const getWhiseCalendarEventsForSelectedAgent = async (startDate, endDate, agentId) => {
        var eventLimit = 300;
        var pageOffset = 0;
        let listOfEvents = [];

        let _response = await getWhiseCalendarEventsByPagination(eventLimit, pageOffset, startDate, endDate, "agent", agentId);

        //get free slots saved in Database only when Synchronization on Whise is disabled
        if (officeSettings.syncEventsToWhise == false) {
            let responseLocalDBEvents = await getCalendarEventsFromDB(startDate, endDate, "agent", agentId);
            if (responseLocalDBEvents.totalCount != undefined && responseLocalDBEvents.totalCount > 0) {
                listOfEvents.push(...responseLocalDBEvents.calendars);
            }
        }

        if (_response.totalCount != undefined && _response.totalCount > 300) {
            listOfEvents.push(..._response.calendars);
            let _afterDivison = _response.totalCount / 300;
            let pages = Math.ceil(_afterDivison);
            for (let i = 1; i < pages; i++) {
                pageOffset = eventLimit * i + 1;
                let _eventResponse = await getWhiseCalendarEventsByPagination(eventLimit, pageOffset, startDate, endDate, "agent", agentId);
                if (_eventResponse.calendars != undefined && _eventResponse.calendars.length > 0) {
                    listOfEvents.push(..._eventResponse.calendars);
                }
            }
        }
        else if (_response.calendars != undefined && _response.calendars.length > 0) {
            listOfEvents.push(..._response.calendars);
        }

        return listOfEvents;
    }

    //Get events from whise with pagination
    //This method will hit twice if in first call event count is greater than 300
    const getWhiseCalendarEventsByPagination = async (eventLimit, pageOffset, startDate, endDate, callingFor, entityId, calendarActions) => {

        let url = "https://api.whise.eu/v1/calendars/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };

        let body = {
            "Filter": {
                "DateTimeRange": {
                    "Min": startDate,
                    "Max": endDate
                },
                "IncludeRecurrences": true
            },
            "Page": {
                "Limit": eventLimit,
                "Offset": pageOffset
            }
        };

        // Conditionally add estate and agentId
        if (callingFor == "estate") {
            body["Filter"]["EstateIds"] = [entityId];
            body["Filter"]["CalendarActionIds"] = calendarActions;
        }
        else {
            body["Filter"]["UserIds"] = [entityId];
        }

        let response = await axios.post(url, body, config);

        return response.data;
    }

    //Get events saved in local database
    const getCalendarEventsFromDB = async (startDate, endDate, callingFor, entityId, calendarActions) => {
        // Generate query string
        let payload = {
            clientId: clientId,
            officeId: officeId,
            startDate: startDate,
            endDate: endDate
        };

        // Conditionally add estateId and agentId
        if (callingFor == "estate") {
            payload.estateId = entityId;
            payload.calendarActions = `${calendarActions}`;
        }
        else {
            payload.agentId = entityId;
        }

        let url = variables.API_URL + `LocalEvents/GetLocalEvent?`;

        const config = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            },
        };

        let response = await axios.post(url, JSON.stringify(payload), config);

        return response.data;
    }

    const deleteCalendarEventsFromDB = async (clientId, estateId) => {
        if (reduxProperty.id) {
            let url = variables.API_URL + `LocalEvents/DeleteEventsByEstateId?clientId=${clientId}&estateId=${reduxProperty.id}`;
            const config = {
                headers: {
                    'Content-Type': 'application/json'
                },
            };

            let response = await axios.post(url, {}, config);

            return response.data;
        }
    }

    const addWhiseCalenderEvent = async (body) => {
        let url = "https://api.whise.eu/v1/calendars/upsert";
        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };

        await axios.post(url, body, config)
            .then(async (response) => {
                setWhiseCalendarEventId(response.data.calendarId);
                /*console.log(response.data.calendarId);*/
                dumpNewlyCreatedWhiseEventInDB(body);
                if (response.data.calendarId !== undefined && reduxEventDetail.invitee != null) {
                    let configuration = {
                        Name: reduxEventDetail.invitee.Name,
                        FirstName: reduxEventDetail.invitee.FirstName,
                        Email: reduxEventDetail.invitee.Email,
                        Mobile: reduxEventDetail.invitee.Mobile,
                        Questions: reduxEventDetail.invitee.Question,
                        Documents: reduxEventDetail.invitee.Documents,
                        AgentRecap: reduxEventDetail.invitee.AgentOnSiteRecap,
                        EventId: response.data.calendarId,
                        ContactId: +contactId,
                    };
                    saveEventConfigurations(configuration);
                }
            })
            .catch(error => {
                showMessage("error", error);
            });
    }

    const dumpNewlyCreatedWhiseEventInDB = async (eventObj) => {
        let url = "https://api.whise.eu/v1/calendars/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };

        const body = {
            Filter: {
                //CalendarIds: [eventId]
                "CalendarActionIds": [eventObj.CalendarActionId],
                "EstateIds": eventObj.EstateIds,
            }
        }

        await axios.post(url, body, config)
            .then(async (response) => {
                if (response.data.totalCount != undefined && response.data.totalCount > 0) {
                    const event = response.data.calendars;
                    console.log(event);
                    /*if (event[0].estates.length > 0) {
                        event[0].estates[0] = reduxProperty;
                    }
                    event[0].clientId = clientId;*/
                    const allEventsList = event.map(item => ({ ...item, clientId: clientId }));
                    //console.log(allEventsList);
                    //await pushEventInDB(event[0]);
                    await pushEventInDB(allEventsList);
                }
            })
            .catch(error => {
                showMessage("error", error);
            });
    }

    const pushEventInDB = async (allEvents) => {
        let url = variables.API_URL + `calendar/SyncWhiseEventCreationInDB?`;

        const config = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            },
        };

       /* console.log("All events:", allEvents);*/
        await axios.post(url, allEvents, config)
            .then(response => { 
                if (response.data) {
                    console.log(response.data);
                    //dumpWhiseEventsOnEstateActivation(event.estates[0].id);
                }
            })
            .catch(error => {
                console.log("error", error);
            });
    }

    const deleteWhiseCalendarEvent = async (eventId, eventConfigration) => {
        //let isEventFromLocalDb = isLocalDbEventToBeDeleted;
        if (eventId) {
            if (eventConfigration == undefined) {
                setShowCalendarLoader(true);
            }
            let url = "https://api.whise.eu/v1/calendars/delete";
            let headers = {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            };
            let body = {
                "CalendarIds": [+eventId]
            };
            axios.delete(url, { data: body, headers: headers })
                .then(response => {
                    if (response.data) {
                        if (eventConfigration != undefined) {
                            addConfirmedWhiseCalenderEvent(eventConfigration);
                        }
                        else {
                            let calendarViewDetails = reduxCalendarView;
                            getWhiseCalenderEvents("onAction", calendarViewDetails.startDate, calendarViewDetails.endDate, calendarViewDetails.view);
                        }
                    }
                    deletCalendarEventFromLocalDB(eventId);
                })
                .catch(error => {
                    console.log("error", error);
                });
        } 
    }

    const deletCalendarEventFromLocalDB = async (eventId) => {

        let url = variables.API_URL + `LocalEvents/DeleteEventsById?eventId=${+eventId}`;

        const config = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            },
        };

        axios.post(url, {}, config)
            .then(response => {
                if (response.data) {
                    setShowCalendarLoader(true);
                    let calendarViewDetails = reduxCalendarView;
                    getWhiseCalenderEvents("onAction", calendarViewDetails.startDate, calendarViewDetails.endDate, calendarViewDetails.view);
                }
            })
            .catch(error => {
                console.log("error", error);
            });
    }

    const handleConfirmWindowClose = () => {
        setShowConfirmWindow(false);
        setIsDeleteConfirmed(false);
        setFreeSlotsEstateIdToBeDeleted(null);
        setClickedDeleteFreeSlotButton(null);
    }

    const callBackConfirmDeleteFreeSlots = (flag) => {
        if (flag == true) {
            setIsDeleteConfirmed(flag);
            setShowConfirmWindow(false);
        }
        else {
            setIsDeleteConfirmed(false);
            setShowConfirmWindow(false);
            setFreeSlotsEstateIdToBeDeleted(null);
            setClickedDeleteFreeSlotButton(null);
        }
    }

    useEffect(() => {
        if (isDeleteConfirmed == true && clickedDeleteFreeSlotButton && freeSlotsEstateIdToBeDeleted) {
            let e = clickedDeleteFreeSlotButton;
            let estateId = freeSlotsEstateIdToBeDeleted;

            setShowCalendarLoader(true);
            e.target.setAttribute("disabled", true);
            e.target.style.cursor = "progress";
            document.querySelector("body").style.cursor = "progress";

            let url = variables.API_URL + `calendar/DeleteEstateFreeSlots?clientId=${clientId}&estateId=${estateId}`;

            const config = {
                headers: {
                    'Authorization': `Bearer ${user.tokenValue}`,
                    'Content-Type': 'application/json'
                },
            };

            axios.post(url, {}, config) // ASP.NET Core API endpoint with header
                .then(async response => {
                    if (response.status == 200) {
                        let _delDbFreeSlotResponse = await deleteCalendarEventsFromDB(clientId, estateId);
                        if (_delDbFreeSlotResponse == "Free slots from db removed successfully.") {
                            let calendarViewDetails = reduxCalendarView;
                            getWhiseCalenderEvents("onAction", calendarViewDetails.startDate, calendarViewDetails.endDate, calendarViewDetails.view);
                            e.target.removeAttribute("disabled");
                            e.target.style.cursor = "";
                            document.querySelector("body").style.cursor = "";
                            setFreeSlotsEstateIdToBeDeleted(null);
                            setClickedDeleteFreeSlotButton(null);
                            setIsDeleteConfirmed(false);
                        }
                    }
                })
                .catch(error => {
                    console.error('Error deleting free slots:', error);
                    setShowCalendarLoader(false);
                    e.target.removeAttribute("disabled");
                    e.target.style.cursor = "";
                    document.querySelector("body").style.cursor = "";
                    setFreeSlotsEstateIdToBeDeleted(null);
                    setClickedDeleteFreeSlotButton(null);
                    setIsDeleteConfirmed(false);
                });
        }
    }, [isDeleteConfirmed, clickedDeleteFreeSlotButton, freeSlotsEstateIdToBeDeleted])

    const handleDeleteAllFreeSlotsClick = async (e, estateId) => {
        setConfirmWindowMessage(reduxLanguageTranslations ? reduxLanguageTranslations["eventDeleteWindowModalYouWantDeleteEventPastFreeSlots"] : "Do you want to delete past free slots?");
        setShowConfirmWindow(true);
        setFreeSlotsEstateIdToBeDeleted(estateId);
        setClickedDeleteFreeSlotButton(e);
    }

    const acceptToBeConfirmedEvents = async (event) => {
        setEventToBeAccepted(event)
        getEstateById(event.estates[0].estateId)
    }

    const getEstateById = (estateId) => {
        let url = "https://api.whise.eu/v1/estates/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };

        axios.post('/user', document.querySelector('#my-form'), {
            headers: {
                'Content-Type': 'application/json'
            }
        })

        axios.post(url, {
            "Filter": {
                "EstateIds": [estateId],
            }
        }, config)
            .then(response => {
                if (response.data.estates != undefined) {
                    setEstateDetailForEventToBeAccepted(response.data.estates);
                }
            })
            .catch(error => {
                console.log("error", error)
            });
    }

    const addConfirmedWhiseCalenderEvent = async (body) => {
        let url = "https://api.whise.eu/v1/calendars/upsert";
        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };

        axios.post(url, body, config)
            .then(response => {
                sendSecondEmail();
                setShowCalendarLoader(false);
            })
            .catch(error => {
                console.log("error", error)
            });
    }

    const sendSecondEmail = () => {
        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        let subject = "Booking Confirmed";
        let estate = estateDetailForEventToBeAccepted[0];



        let html = "<div style='border: 1px solid #FAFAFA; background-color: white; border-radius: 16px; padding: 20px; width: 80%; margin: 0 auto; text-align: left'>";
        html += "   <div><img src='https://mink-smartcalendar-agent-ui.net7.be/static/media/sidebar-logo.c2f1f3f5618f7e01cbfd4410196de7f5.svg' style='margin-bottom: 1.5rem' /></div>";
        html += "   <h5 style='font-size: 24px;font-weight: 500;color: #111827;font-family: Poppins; margin: 0; margin-bottom: 1.5rem'>Your Visit request has been accepted by <strong>" + eventToBeAccepted.users[0].name + "</strong> of the agency " + eventToBeAccepted.users[0].officeId + "</h5>";
        html += "   <div  style='margin-bottom: 1.5rem; border: 1px solid #FAFAFA; border-radius: 8px; text-align: left; padding: 15px;'>";
        html += "       <h5 style='font-family: Poppins; font-size: 16px; line-height: 20.8px; color: #111827; margin: 0; margin-bottom: 1rem'>You're visiting the property located:</h5>";
        html += "       <p style='font-family: Poppins; font-size: 14px; line-height: 20.8px; color: #111827; margin: 0; margin-bottom: 1rem'>" + (estate.address == undefined ? "" : estate.address) + " " + (estate.number == undefined ? "" : estate.number) + ", " + (estate.zip == undefined ? "" : estate.zip) + " " + (estate.city == undefined ? "" : estate.city) + "</p>";
        html += "       <h5 style='font-family: Poppins; font-size: 16px; line-height: 20.8px; color: #111827; margin: 0; margin-bottom: 1rem; margin-top: 1.5rem'>Date</h5>";
        html += "       <p style='font-family: Poppins; font-size: 14px; line-height: 20.8px; color: #111827; margin: 0;'>" + new Date(eventToBeAccepted.startDateTime) + "</p>";
        html += "   </div>";
        html += "   <div style='margin-bottom: 1.5rem; background-color: #FBEFEF; border-radius: 8px; text-align: left; padding: 15px;'>";
        html += "       <h5 style='font-family: Poppins; font-size: 16px; line-height: 20.8px; color: #111827; margin: 0; margin-bottom: 1rem; color: #CF132A'>Remarque</h5>";
        html += "       <p style='margin: 0; font-family: Poppins; font-size: 14px;'>You will receive second email confirmation from the agency with the electronic invitation to add on your agenda. Later, if you're not able to attend to the visit appointment please come back on this email and click on the button below OR call the agency at +32 02 487 878</p>";
        html += "   </div>";
        html += "   <div style='display: flex; align-items: center; justify-content: space-between; font-family: Poppins'>"
        html += "       <a href='#' style='margin-right: 10px; border: 1px solid #111827; text-decoration: none; width: 100%; padding: 9px 10px; border-radius: 8px; text-align: center; color: #111827; font-size: 14px'>Cancel the Visit</a>"
        html += "       <a href='#' style='background-color: #274B97; color: white; text-decoration: none; width: 100%; padding: 10px; border-radius: 8px; text-align: center;font-size: 14px'>Reschedule the Visit</a>"
        html += "   </div>"
        html += "</div> ";


        let email = "";
        if (eventToBeAccepted.contacts[0].privateEmail != undefined && eventToBeAccepted.contacts[0].privateEmail != "") {
            email = eventToBeAccepted.contacts[0].privateEmail;
        }
        else {
            email = eventToBeAccepted.contacts[0].businessEmail;
        }
        let sendTo = email;

        let objEmail = {
            emailTo: sendTo,
            body: html,
            subject: subject
        }

        const url = variables.API_URL + `Email/SendEmail?`;
        axios.post(url, JSON.stringify(objEmail), jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                var resp = response.data;
                setEventToBeAccepted(null);
                setEstateDetailForEventToBeAccepted(null);
                setShowCalendarLoader(true);
                handleClose();
                let calendarViewDetails = reduxCalendarView;
                getWhiseCalenderEvents("onAction", calendarViewDetails.startDate, calendarViewDetails.endDate, calendarViewDetails.view);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const saveEventConfigurations = (config) => {

        let url = variables.API_URL + `InviteeConfiguration/SaveConfigurations?`;
        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };
        axios.post(url, JSON.stringify(config), jsonconfig) // ASP.NET Core API endpoint with header
            .then(response => {
                handleClose();
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const saveBookableUntilLimit = async () => {

        let url = "";
        if (reduxBookAbleUntil && reduxBookAbleUntil.label && reduxBookAbleUntil.value) {
            url = variables.API_URL + `Calendar/SaveBookableUntilLimitForEstate?clientId=${clientId}&estateId=${reduxProperty.id}&type=${reduxBookAbleUntil.label}&value=${reduxBookAbleUntil.value}`;
        }
        else {
            url = variables.API_URL + `Calendar/SaveBookableUntilLimitForEstate?clientId=${clientId}&estateId=${reduxProperty.id}`;
        }

        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };

        await axios.post(url, {}, jsonconfig) // ASP.NET Core API endpoint with header
            .then(response => {
                const value = response.data;
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const saveNewWhiseEvent = async (e) => {
        e.target.setAttribute("disabled", true);
        e.target.style.cursor = "progress";
        document.querySelector("body").style.cursor = "progress";
        if (contactId > 0) {
            if (reduxEventDetail.event != null && reduxEventDetail.availableHours != null) {

                let agentIds = reduxAgent.map(item => { return item.value });
                let address = "";
                if (reduxEventDetail.event.EventAddress == "property") {
                    address += reduxProperty.address == undefined ? "" : reduxProperty.address + " ";
                    address += reduxProperty.number == undefined ? "" : reduxProperty.number + ", ";
                    address += reduxProperty.zip == undefined ? "" : reduxProperty.zip;
                    address += reduxProperty.city == undefined ? "" : " " + reduxProperty.city;
                }
                else {
                    address += whiseOffice.address == undefined ? "" : whiseOffice.address + " ";
                    address += whiseOffice.number == undefined ? "" : whiseOffice.number + ", ";
                    address += whiseOffice.zip == undefined ? "" : whiseOffice.zip;
                    address += whiseOffice.city == undefined ? "" : " " + whiseOffice.city;
                }

                let subject = getAction(reduxEventDetail.event.EventType) + ": " + address;
                //let subject = getAction(reduxEventDetail.event.EventType);
                for (const item of reduxEventDetail.availableHours) {
                    let bookAbleDateTime = new Date();
                    let itemDateTime = new Date(item.StartDateTime.replace("Z", ""));
                    if (reduxBookAbleUntil) {
                        if (reduxBookAbleUntil.label == "days") {
                            bookAbleDateTime.setDate(bookAbleDateTime.getDate() + parseInt(reduxBookAbleUntil.value, 10));
                        }
                        else {
                            bookAbleDateTime.setHours(bookAbleDateTime.getHours() + parseInt(reduxBookAbleUntil.value, 10));
                        }
                    }
                    if (itemDateTime > bookAbleDateTime) {
                        try {
                            let configration = {
                                CalendarActionId: reduxEventDetail.event.EventType,
                                StartDateTime: item.StartDateTime,
                                EndDateTime: item.EndDateTime,
                                AllDay: item.AllDay,
                                Private: false,
                                Subject: subject,
                                UserIds: agentIds,
                                EstateIds: [reduxProperty.id],
                                ContactIds: [+contactId],
                                Description1: "SmartCalendar Db Event"
                            };

                            if (officeSettings.syncEventsToWhise) {
                                configration["Description1"] = "SmartCalendar Whise Event";
                                await addWhiseCalenderEvent(configration);
                            } else {
                                configration["Description1"] = "SmartCalendar Db Event";
                                await addCalenderEventInDB(configration);
                            }
                            await GetSuspendedEstateIds();
                            //await markEstateActiveInDB(reduxProperty);

                            //if (reduxBookAbleUntil && reduxBookAbleUntil.label != null && reduxBookAbleUntil.value != null) {
                            saveBookableUntilLimit();
                            //}

                        } catch (error) {
                            console.error("Error processing calendar event:", error);
                        }
                    }
                }

                e.target.removeAttribute("disabled");
                e.target.style.cursor = "";
                document.querySelector("body").style.cursor = "";
            }
        }
    }

    const addCalenderEventInDB = async (body) => {

        let url = variables.API_URL + "LocalEvents/SaveEventInDatabase?";
        const config = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            },
        };
        body.ClientId = clientId;

        axios.post(url, body, config)
            .then(response => {
                setWhiseCalendarEventId(response.data.calendarId);
                if (response.data.calendarId != undefined) {
                    if (reduxEventDetail.invitee != null) {
                        let configuration = {
                            Name: reduxEventDetail.invitee.Name,
                            FirstName: reduxEventDetail.invitee.FirstName,
                            Email: reduxEventDetail.invitee.Email,
                            Mobile: reduxEventDetail.invitee.Mobile,
                            Questions: reduxEventDetail.invitee.Question,
                            Documents: reduxEventDetail.invitee.Documents,
                            AgentRecap: reduxEventDetail.invitee.AgentOnSiteRecap,
                            EventId: response.data.calendarId,
                            ContactId: +contactId,
                        };
                        saveEventConfigurations(configuration);
                    }
                }
            })
            .catch(error => {
                showMessage("error", error);
            });
    }

    const clickHandlerEventPreview = async (e) => {
        let eventDetail = e.event.extendedProps;
        setPreviewEventDetail(eventDetail)
        setShowModal(true);
        setPreviewEvent(true);
    }

    const changeHandlerSearchByEstateId = (e) => {
        let value = e.target.value;
        let isnum = /^\d+$/.test(value);

        setShowPropertiesLoader(true);

        let filteredList = clientEstates;

        if (value !== "" && isnum == true) {
            setEstateId(value);
            let filteredEstatesList = filteredList.filter(item => {
                let itemEstateId = item.id + "";
                return itemEstateId.includes(value);
            })
            setFilteredEstates(filteredEstatesList);
            setShowPropertiesLoader(false);
        }
        else if (value == "") {
            if (estateSearch != "") {
                let listAfterFirstFilter = filteredList.filter(item => {
                    let itemPrice = item.price != undefined ? item.price + "" : "";
                    let city = item.city != undefined ? item.city.toLowerCase() : "";
                    let address = item.address != undefined ? item.address.toLowerCase() : "";
                    let zip = item.zip != undefined ? item.zip.toLowerCase() : "";
                    let number = item.number != undefined ? item.number.toLowerCase() : "";
                    return city.includes(estateSearch) || address.includes(estateSearch) || itemPrice.includes(estateSearch) || zip.includes(estateSearch) || number.includes(estateSearch);
                });

                filteredList = listAfterFirstFilter;
            }
            if (purposeStatusId != "") {
                let listAfterSecondFilter = filteredList.filter(item => {
                    return item.purpose.id == purposeStatusId;
                });
                filteredList = listAfterSecondFilter;
            }
            if (displayStatusIds.length > 0) {
                const modifyDisplayStausSelectedIds = displayStatusIds.map((item) => +item.value); // [1,2,3]
                let listAfterThirdFilter = filteredList.filter(item =>
                    modifyDisplayStausSelectedIds.includes(item.displayStatusId)
                );
                filteredList = listAfterThirdFilter;
            }
            if (selectOffice != "") {
                let listAfterFourFilter = filteredList.filter(item => {
                    return item.officeId == selectOffice;
                })
                filteredList = listAfterFourFilter;
            }
            setEstateId("");
            setFilteredEstates(filteredList);
            setShowPropertiesLoader(false);
        }
    }

    const changeHandlerSearchByEstateProps = (e) => {
        let value = e.target.value.toLowerCase();

        let filteredList = clientEstates;
        if (estateId != "") {
            let listAfterFirstFilter = filteredList.filter(item => {
                let itemEstateId = item.id + "";
                return itemEstateId.includes(estateId);
            });
            filteredList = listAfterFirstFilter
        }
        if (purposeStatusId != "") {
            let listAfterSecondFilter = filteredList.filter(item => {
                return item.purpose.id == purposeStatusId;
            });
            filteredList = listAfterSecondFilter;
        }
        if (displayStatusIds.length > 0) {
            const modifyDisplayStausSelectedIds = displayStatusIds.map((item) => +item.value); // [1,2,3]
            let listAfterThirdFilter = filteredList.filter(item =>
                modifyDisplayStausSelectedIds.includes(item.displayStatusId)
            );
            filteredList = listAfterThirdFilter;
        }
        if (selectOffice != "") {
            let listAfterFourFilter = filteredList.filter(item => {
                return item.officeId == selectOffice;
            })
            filteredList = listAfterFourFilter;
        }

        if (value !== "") {
            setEstateSearch(value);
            let filteredEstatesList = filteredList.filter(item => {
                let itemPrice = item.price != undefined ? item.price + "" : "";
                let city = item.city != undefined ? item.city.toLowerCase() : "";
                let address = item.address != undefined ? item.address.toLowerCase() : "";
                let zip = item.zip != undefined ? item.zip.toLowerCase() : "";
                let number = item.number != undefined ? item.number.toLowerCase() : "";
                return city.includes(value) || address.includes(value) || itemPrice.includes(value) || zip.includes(value) || number.includes(value);
            })
            setFilteredEstates(filteredEstatesList);
        }
        else {
            setEstateSearch("");
            setFilteredEstates(filteredList);
        }
    }

    const changeHandlerPurposeStatusFilter = (e) => {
        let value = e.target.value;

        let filteredList = clientEstates;
        if (estateSearch != "") {
            let listAfterFirstFilter = filteredList.filter(item => {
                let itemPrice = item.price != undefined ? item.price + "" : "";
                let city = item.city != undefined ? item.city.toLowerCase() : "";
                let address = item.address != undefined ? item.address.toLowerCase() : "";
                let zip = item.zip != undefined ? item.zip.toLowerCase() : "";
                let number = item.number != undefined ? item.number.toLowerCase() : "";
                return city.includes(estateSearch) || address.includes(estateSearch) || itemPrice.includes(estateSearch) || zip.includes(estateSearch) || number.includes(estateSearch);
            });
            filteredList = listAfterFirstFilter;
        }
        if (estateId != "") {
            let listAfterSecondFilter = filteredList.filter(item => {
                let itemEstateId = item.id + "";
                return itemEstateId.includes(estateId);
            });
            filteredList = listAfterSecondFilter;
        }
        if (displayStatusIds.length > 0) {
            const modifyDisplayStausSelectedIds = displayStatusIds.map((item) => +item.value); // [1,2,3]
            let listAfterThirdFilter = filteredList.filter(item =>
                modifyDisplayStausSelectedIds.includes(item.displayStatusId)
            );
            filteredList = listAfterThirdFilter;
        }
        if (selectOffice != "") {
            let listAfterFourFilter = filteredList.filter(item => {
                return item.officeId == selectOffice;
            })
            filteredList = listAfterFourFilter;
        }

        if (value != "") {
            setPurposeStatusId(value);
            let filteredEstatesList = filteredList.filter(item => {
                return item.purpose.id == value;
            })
            setFilteredEstates(filteredEstatesList);
            if (filteredEstatesList.length > 0) {
                setSelectedProperty(filteredEstatesList[0]);
                dispatch(setselectedproperty(filteredEstatesList[0]));
            }
        }
        else {
            setPurposeStatusId("");
            setFilteredEstates(filteredList);
            if (filteredList.length > 0) {
                setSelectedProperty(filteredList[0]);
                dispatch(setselectedproperty(filteredList[0]));
            }
        }
    }

    const changeHandlerDisplayStatusFilter = (event) => {
        /* setDisplayStatusId(event);*/
        const value = event;

        let filteredList = clientEstates;
        if (estateSearch != "") {
            let listAfterFirstFilter = filteredList.filter(item => {
                let itemPrice = item.price != undefined ? item.price + "" : "";
                let city = item.city != undefined ? item.city.toLowerCase() : "";
                let address = item.address != undefined ? item.address.toLowerCase() : "";
                let zip = item.zip != undefined ? item.zip.toLowerCase() : "";
                let number = item.number != undefined ? item.number.toLowerCase() : "";
                return city.includes(estateSearch) || address.includes(estateSearch) || itemPrice.includes(estateSearch) || zip.includes(estateSearch) || number.includes(estateSearch);
            });
            filteredList = listAfterFirstFilter;
        }
        if (estateId != "") {
            let listAfterSecondFilter = filteredList.filter(item => {
                let itemEstateId = item.id + "";
                return itemEstateId.includes(estateId);
            });
            filteredList = listAfterSecondFilter;
        }
        if (purposeStatusId != "") {
            let listAfterThirdFilter = filteredList.filter(item => {
                return item.purpose.id == purposeStatusId;
            });
            filteredList = listAfterThirdFilter;
        }
        if (selectOffice != "") {
            let listAfterFourFilter = filteredList.filter(item => {
                return item.officeId == selectOffice;
            })
            filteredList = listAfterFourFilter;
        }

        if (value.length > 0) {
            /*let filteredEstatesList = filteredList.filter(item => {
                return item.displayStatusId == value;
            })*/
            setDisplayStatusIds(value);
            const modifyDisplayStausSelectedIds = value.map((item) => +item.value); // [1,2,3]
            let filteredEstatesList = filteredList.filter(item =>
                modifyDisplayStausSelectedIds.includes(item.displayStatusId)
            );
            setFilteredEstates(filteredEstatesList);
        }
        else {
            setDisplayStatusIds([]);
            setFilteredEstates(filteredList);

        }
    }

    const changehandlerSelectOfficeFilter = (e) => {
        const value = e.target.value;

        let filteredList = clientEstates;
        if (estateSearch != "") {
            let listAfterFirstFilter = filteredList.filter(item => {
                let itemPrice = item.price != undefined ? item.price + "" : "";
                let city = item.city != undefined ? item.city.toLowerCase() : "";
                let address = item.address != undefined ? item.address.toLowerCase() : "";
                let zip = item.zip != undefined ? item.zip.toLowerCase() : "";
                let number = item.number != undefined ? item.number.toLowerCase() : "";
                return city.includes(estateSearch) || address.includes(estateSearch) || itemPrice.includes(estateSearch) || zip.includes(estateSearch) || number.includes(estateSearch);
            });
            filteredList = listAfterFirstFilter;
        }
        if (estateId != "") {
            let listAfterSecondFilter = filteredList.filter(item => {
                let itemEstateId = item.id + "";
                return itemEstateId.includes(estateId);
            });
            filteredList = listAfterSecondFilter;
        }
        if (displayStatusIds.length > 0) {
            const modifyDisplayStausSelectedIds = displayStatusIds.map((item) => +item.value); // [1,2,3]
            let listAfterThirdFilter = filteredList.filter(item =>
                modifyDisplayStausSelectedIds.includes(item.displayStatusId)
            );
            filteredList = listAfterThirdFilter;
        }
        if (purposeStatusId != "") {
            let filteredEstatesList = filteredList.filter(item => {
                return item.purpose.id == purposeStatusId;
            })
            setFilteredEstates(filteredEstatesList);
            filteredList = filteredEstatesList;
        }

        if (value != "") {
            setSelectOffice(value);
            let filteredEstatesList = filteredList.filter(item => {
                return item.officeId == value;
            })
            setFilteredEstates(filteredEstatesList);
            filteredList = filteredEstatesList;
        }
        else {
            setSelectOffice("");
            setFilteredEstates(filteredList);
        }
    }

    const handlerClearEstateFilter = (e) => {
        setDisplayStatusIds([]);
        setPurposeStatusId("");
        setSelectOffice("");

        let filteredList = clientEstates;
        if (estateSearch != "") {
            let listAfterFirstFilter = filteredList.filter(item => {
                let itemPrice = item.price != undefined ? item.price + "" : "";
                let city = item.city != undefined ? item.city.toLowerCase() : "";
                let address = item.address != undefined ? item.address.toLowerCase() : "";
                let zip = item.zip != undefined ? item.zip.toLowerCase() : "";
                let number = item.number != undefined ? item.number.toLowerCase() : "";
                return city.includes(estateSearch) || address.includes(estateSearch) || itemPrice.includes(estateSearch) || zip.includes(estateSearch) || number.includes(estateSearch);
            });
            filteredList = listAfterFirstFilter;
        }
        if (estateId != "") {
            let listAfterSecondFilter = filteredList.filter(item => {
                let itemEstateId = item.id + "";
                return itemEstateId.includes(estateId);
            });
            filteredList = listAfterSecondFilter;
        }
        setFilteredEstates(filteredList);
    }

    const formatPrice = (price, symbol) => {
        let formattedPrice = new Intl.NumberFormat('fr-BE', { style: 'currency', currency: 'EUR' }).format(price,);
        //let index = formattedPrice.indexOf(symbol);

        //let finalPrice = formattedPrice.substr(index+1)

        //return finalPrice + " " + symbol;
        return formattedPrice;
    }

    const getWhiseOffices = () => {
        let url = "https://api.whise.eu/v1/admin/offices/list";

        const config = {
            headers: {
                'Authorization': `Bearer ${whiseUserToken}`,
                'Content-Type': 'application/json'
            },
        };

        axios.post(url, { "clientId": clientId }, config)
            .then(response => {
                if (response.data.offices != undefined) {
                    setOfficeList(response.data.offices);
                    setSelectOffice(response.data.offices[0].id);
                    var _filteredOffice = response.data.offices.filter((item) => { return item.id == officeId });
                    setWhiseOffice(_filteredOffice[0]);
                    setIsOfficesLoaded(true);
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const handleDropdownToggle = (e, dropdownId, property) => {
        e.stopPropagation();
        handlerPropertyClick(property);
        setOpenDropdownId(prevId => prevId === dropdownId ? null : dropdownId); // Toggle dropdown visibility
    };

    //languages save in redux store 
    const getAllLanguage = () => {
        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        const url = variables.API_URL + `Settings/GetAllLanguages`;
        axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                let getLanguages = response.data;
                dispatch(setlanguages(getLanguages));
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const copToClipBoard = (link) => {
        navigator.clipboard.writeText(link);
    }

    const editEstateConfigurations = (e, estateId) => {
        setIsEstateConfigurationsEdit(true);
        setShowModal(true);
    }

    useEffect(() => {
        if (eventToBeAccepted != null && estateDetailForEventToBeAccepted != null) {
            setShowModal(false);
            setShowCalendarLoader(true);
            let confirmedId = confirmedIds[0];
            if (estateDetailForEventToBeAccepted[0].purpose.id === 2) {
                confirmedId = confirmedIds[1];
            }

            let subject = getAction(confirmedId);

            let address = "";
            address += estateDetailForEventToBeAccepted[0].address == undefined ? "" : estateDetailForEventToBeAccepted[0].address + " ";
            address += estateDetailForEventToBeAccepted[0].number == undefined ? "" : estateDetailForEventToBeAccepted[0].number + ", ";
            address += estateDetailForEventToBeAccepted[0].zip == undefined ? "" : estateDetailForEventToBeAccepted[0].zip;
            address += estateDetailForEventToBeAccepted[0].city == undefined ? "" : " " + estateDetailForEventToBeAccepted[0].city;

            let configration = {
                "CalendarActionId": confirmedId,
                "StartDateTime": eventToBeAccepted.startDateTime,
                "EndDateTime": eventToBeAccepted.endDateTime,
                "AllDay": "false",
                "Private": false,
                "subject": subject, //"private",
                "UserIds": [eventToBeAccepted.users[0].userId],
                "EstateIds": [estateDetailForEventToBeAccepted[0].id],
                "ContactIds": [eventToBeAccepted.contacts[0].contactId]
            }
            deleteWhiseCalendarEvent(eventToBeAccepted.eventId, configration);
        }
    }, [eventToBeAccepted, estateDetailForEventToBeAccepted])

    const usePrevious = (value) => {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        });
        return ref.current;
    };

    useEffect(() => {
        setShowCalendarLoader(true);
        if (clientToken != "" && freeSlotIds.length > 0 && selectedProperty) {
            if (reduxCalendarView) {
                let calendarViewDetails = reduxCalendarView;
                getWhiseCalenderEvents("onAction", calendarViewDetails.startDate, calendarViewDetails.endDate, calendarViewDetails.view);
            }
            else {
                getWhiseCalenderEvents("default");
            }
        }
    }, [clientToken, selectedAgents, selectedProperty, selectedStatuses, whiseCalendarEventId, freeSlotIds]);

    useEffect(() => {
        if (whiseUserToken && reduxClientToken != null) {
            //getClientToken();
            setClientToken(reduxClientToken);
            getAgents(reduxClientToken);
            getEstateIdsHavingConfigSaved();
           /* if (isOfficesLoaded == false) {
                getWhiseOffices();
            }*/
        }
        if (reduxSelectedLanguage && reduxClientToken != null && freeSlotIds.length > 0 && selectOffice != "") {
            getClientWhiseEstatesList(reduxClientToken);
        }
    }, [whiseUserToken, reduxClientToken, reduxSelectedLanguage, freeSlotIds, selectOffice])


    //this code will execute only one time to load whise events of all estates of a client in Database
    useEffect(() => {
        const syncEvents = async () => {
            if (clientEstates.length > 0 && freeSlotIds.length > 0 && tobeConfirmedIds.length > 0 && confirmedIds.length > 0 && user) {
                if (user.user.firstSynchronization) {
                    return;
                }

                setShowSynchingLoader(true);

                let savedCalendarActions = [...new Set([...freeSlotIds, ...tobeConfirmedIds, ...confirmedIds])];
                //let savedCalendarActions = [...new Set([...freeSlotIds])];
                const startDate = toLocalISOString(new Date());

                for (const estate of clientEstates) {
                    let eventLimit = 300;
                    let pageOffset = 0;
                    let listOfEvents = [];

                    const _response = await fetchEventsForFirstSynchronization(startDate, estate.id, savedCalendarActions, estate, eventLimit, pageOffset);
                    console.log(_response);
                    if (_response.totalCount !== undefined && _response.totalCount > 300) {
                        listOfEvents.push(..._response.calendars);
                        const pages = Math.ceil(_response.totalCount / 300);
                        for (let i = 1; i < pages; i++) {
                            pageOffset = eventLimit * i + 1;
                            const _eventResponse = await fetchEventsForFirstSynchronization(startDate, estate.id, savedCalendarActions, estate, eventLimit, pageOffset);
                            if (_eventResponse.calendars?.length > 0) {
                                listOfEvents.push(..._eventResponse.calendars);
                            }
                        }
                    } else if (_response.calendars?.length > 0) {
                        listOfEvents.push(..._response.calendars);
                    }

                   /* for (const event of listOfEvents) {
                        if (event.estates.length > 0) {
                            event.estates[0] = estate;
                        }
                        await pushEventInDB(event[0]);
                    }*/

                    /*console.log(listOfEvents);*/

                    const addClientIdInListOfEvents = listOfEvents.map((item) => ({...item, clientId: +clientId }));
                    console.log(addClientIdInListOfEvents);
                    //await pushEventInDB(listOfEvents);
                    await dumpEventsInLocalDBOnFirstSynchronization(addClientIdInListOfEvents);
                }

                // all done
                await updateSynchronizationFlag();
            }
        };

        syncEvents();
    }, [clientEstates, freeSlotIds, tobeConfirmedIds, confirmedIds, user]);


    const fetchEventsForFirstSynchronization = async (minDate, estateId, actionIds, estate, eventLimit, pageOffset) => {
        let url = "https://api.whise.eu/v1/calendars/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };

        let body = {
            "Filter": {
                "DateTimeRange": {
                    "Min": minDate
                },
                "EstateIds": [estateId],
                "CalendarActionIds": actionIds
            },
            "Page": {
                "Limit": eventLimit,
                "Offset": pageOffset
            }
        };

        let response = await axios.post(url, body, config);

        return response.data;
    }

    const dumpEventsInLocalDBOnFirstSynchronization = async (allWhiseEventsList) => {
        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };

        const url = variables.API_URL + `Calendar/DumpEventsOnFirstSync`;

        try {
            const response = await axios.post(url, allWhiseEventsList, jsonconfig);
            const message = response.data;
            console.log(message);
        } catch (error) {
            console.error('Error dump events in local db on first sync', error);
            showMessage("error", error);
        }
    }

    const updateSynchronizationFlag = async () => {
        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };

        const url = variables.API_URL + `User/UpdateSynchronizationFlag?clientId=${clientId}`;

        try {
            const response = await axios.post(url, {}, jsonconfig);
            const message = response.data;
            if (message == "updated") {
                const _user = {
                    ...user,
                    user: {
                        ...user.user,
                        firstSynchronization: true
                    }
                };
                dispatch(login(_user));
                setShowCalendarLoader(false);
                setShowSynchingLoader(false);
            }
        } catch (error) {
            console.error('Error while updating synchronization flag:', error);
            showMessage("error", error);
        }
    }

    useEffect(() => {
        if (actions != null && actions != undefined) {
            setCalendarActions(actions);
        }
    }, [actions])

    useEffect(() => {
        if (container != null) {
            let contHeight = container.current.offsetHeight;
            setHeight(contHeight);
        }
        //if (document.getElementById("schedularContainer") != null) {
        //    let calendarHeight = document.getElementById("schedularContainer").offsetHeight;
        //    setHeight(calendarHeight - 42);
        //}
    }, [container]);

    useEffect(() => {
        if (reduxProperty != null && reduxProperty.purpose.id == purposeStatusId) {
            setSelectedProperty(reduxProperty);
            //dispatch(setselectedproperty(reduxProperty));
        }
        else if ((reduxProperty == null || reduxProperty.purpose.id != purposeStatusId) && filteredEstates.length > 0) {
            setSelectedProperty(current => filteredEstates[0]);
            dispatch(setselectedproperty(filteredEstates[0]));
        }

    }, [filteredEstates])

    useEffect(() => {
        getOfficeSettings();
        getAllLanguage();
        if (reduxStatus != undefined && reduxStatus !== null && reduxStatus.length > 0) {
            setSelectedStatuses(reduxStatus);
        }
        if (reduxAgent != undefined && reduxAgent != null) {
            setSelectedAgents(reduxAgent);
        }
        setTimeout(() => {
            if (reduxIsSidebarCollapsed == false) {
                dispatch(setSidebarCollapsed(true));
            }
            setIsPropertiesCollapsed(true);
        }, 5000);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (openDropdownId !== null && !event.target.closest('.estate-drop-menu')) {
                setOpenDropdownId(null); // Close dropdown when clicked outside
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openDropdownId]);

    const GetActivatedEstateIds = useCallback(async () => {
        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };

        const url = variables.API_URL + `Estate/GetActivatedEstateIds?clientId=${clientId}`;

        try {
            const response = await axios.get(url, jsonconfig);
            const ids = response.data;

            if (Array.isArray(ids)) {
                setActivatedEstates(prev => [...new Set([...prev, ...ids])]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showMessage("error", error);
        }
    }, [clientId, user.tokenValue]);

    useEffect(() => {
        if (clientId) {
            GetActivatedEstateIds();
            GetSuspendedEstateIds();
        }
    }, [clientId, GetActivatedEstateIds]);

    const GetSuspendedEstateIds = async () => {
        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };

        const url = variables.API_URL + `Calendar/GetSuspendedEstateIds?clientId=${clientId}`;

        try {
            const response = await axios.get(url, jsonconfig);
            const ids = response.data;

            if (Array.isArray(ids)) {
                setSuspendedEstates(prev => [...new Set([...prev, ...ids])]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showMessage("error", error);
        }
    }

    const markEstateActiveInDB = async (estate) => {

        let url = variables.API_URL + "Estate/ActivateEstateInDB?";
        const config = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            },
        };

        const filteredDetails = estate.details.filter(detail =>
            detail.id === 1849 || detail.id === 1850
        );

        const xCoordinate = filteredDetails.filter(detail =>
            detail.id === 1849
        );

        const yCoordinate = filteredDetails.filter(detail =>
            detail.id === 1850
        );

        var body = {
            Id: estate.id,
            ClientId: estate.clientId,
            Address: estate?.address ?? null,
            Address2: estate?.address2 ?? null,
            Box: estate?.box ?? null,
            City: estate?.city ?? null,
            Comments: estate?.comments ?? null,
            Floor: estate?.floor ?? null,
            Name: estate?.name ?? null,
            Number: estate?.number ?? null,
            OfficeId: estate.officeId,
            ParentId: estate?.parentId ?? null,
            Price: estate?.price ?? null,
            XCoordinate: xCoordinate[0].value,
            YCoordinate: yCoordinate[0].value,
            Zip: estate?.zip ?? null,
            UrlSmall: estate?.pictures?.[0]?.UrlSmall ?? null,
            BathRooms: estate?.bathRooms ?? null,
            Rooms: estate?.rooms ?? null,
            Area: estate?.area ?? null,
            SmartCalendarStatus: true,

            // ✅ Fix nested object fields here
            CountryId: estate.country?.id ?? null,
            SubcategoryId: estate.subCategory?.id ?? null,
            StatusId: estate.status?.id ?? null,
        }

        try {
            const response = await axios.post(url, body, config);

            if (response.status === 200) {
                setActivatedEstates(prev => [...prev, estate.id]);

                // Await the inner async call and catch any errors
                await dumpWhiseEventsOnEstateActivation(estate.id);
            } else {
                showMessage("error", "Unexpected response from server.");
            }
        } catch (error) {
            console.error('Error activating estate:', error);
            showMessage("error", "Error activating estate: " + error.message);
        }
    }

    const dumpWhiseEventsOnEstateActivation = async (estateId) => {
        try {
            //let savedCalendarActions = [...new Set([...freeSlotIds, ...tobeConfirmedIds, ...confirmedIds])];
            let savedCalendarActions = [...new Set([...freeSlotIds])];

            let url = variables.API_URL + `calendar/FetchAndDumpEventsOnEstateActivation`;

            const config = {
                headers: {
                    'Authorization': `Bearer ${user.tokenValue}`,
                    'Content-Type': 'application/json'
                },
            };

            const body = {
                ClientId: clientId,
                ActionIds: savedCalendarActions,
                EstateId: estateId
            };

            const response = await axios.post(url, body, config);

            if (response.data === "Success") {
                showMessage("success", "Estate is successfully activated and WHISE events loaded.");
            } else {
                showMessage("error", "Unexpected response from server.");
            }
        } catch (error) {
            console.error("Error dumping WHISE events:", error);
            showMessage("error", "Failed to load WHISE events: " + error.message);
        }
    }

    const markEstateDeactiveInDB = async (estate) => {

        let url = variables.API_URL + `Estate/DeactivateEstateInDB?estateId=${estate.id}`;
        const config = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            },
        };

        var body = {}

        await axios.post(url, body, config)
            .then(response => {
                if (response.status === 200) {
                    showMessage("success", response.data);
                    var activatedList = [...activatedEstates];
                    const updatedList = activatedList.filter(id => id !== estate.id);
                    setActivatedEstates(updatedList);
                } else {
                    showMessage("error", "Unexpected response from server.");
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                showMessage("error", error);
            });
    }

    return (
        <>
            <div className={`${isPropertiesCollapsed == true ? "ps-4 pe-0" : "px-4"}`}>
                <div className="row">
                    <div className={`${isPropertiesCollapsed == true ? "col-sm-11" : "col-12 col-sm-8 col-md-9 col-lg-9 col-xl-9"}`}>
                        <div className="d-flex align-items-center justify-content-between pb-3">
                            <span className="form-title">
                                {reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageTitle"] : "Calendar"}
                            </span>
                            <div className="d-flex">
                                <Dropdown.Toggle className={`filter-btn ${showHideCalendarFilter == true ? "dropup" : ""}`}
                                    id="calendarFilter" onClick={showCalendarFilters} >
                                    <img src={filterIcon} className="pe-2" />
                                    <span className="pe-3">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterBtn"] : "Filter"}</span>
                                    {
                                        reduxAgent != null && reduxAgent.length != 0 || reduxStatus != null && reduxStatus !== undefined && reduxStatus.length != 0 ?
                                            //<img src={clearCross} className="me-1" />
                                            <button className="clear-btn" onClick={handlerClearCalenderFilter}>
                                                {reduxLanguageTranslations ? reduxLanguageTranslations["clearFilterButtonLabel"] : "Clear"}
                                                <img src={whiteCross} />
                                            </button>
                                            : <></>
                                    }
                                </Dropdown.Toggle>
                                <button className="site-btn ms-2" onClick={handlerAddSlot}>
                                    <img src={plusIcon} />{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageAddSlotBtn"] : "Add Slot"}
                                </button>
                            </div>
                        </div>
                        <div className={`form-container mb-3 ${showHideCalendarFilter == true ? "" : "d-none"}`}>
                            <div className="row mb-3">
                                <div className="col-md-4 col-12">
                                    <div className="form-group">
                                        <label className="form-group-label mt-0" htmlFor="property">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownPropertyLbl"] : "Property"}</label>
                                        <select className="form-select" id="property" disabled>
                                            {
                                                selectedProperty != null && selectedProperty.id != undefined ?
                                                    <option value={selectedProperty.id}>{selectedProperty.name}</option>
                                                    :
                                                    <></>
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-4 col-12">
                                    <div className="form-group">
                                        <label className="form-group-label mt-0" htmlFor="agent">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownAgentLbl"] : "Agent"}<span>*</span></label>
                                        <select className="form-select" onChange={changeHandlerAgentFilter} value={selectedAgents.length > 0 ? selectedAgents[0].value : ""}>
                                            <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownAgentSelect"] : "Select Agent"}</option>
                                            {
                                                whiseAgents.length > 0 ? whiseAgents.map((item, i) => {
                                                    return (
                                                        <option value={item.id} data-agent={JSON.stringify(item)} key={i}>{item.firstName + " " + item.name}</option>
                                                    )
                                                })
                                                    :
                                                    <></>
                                            }
                                        </select>
                                        {/*<MultiSelect*/}
                                        {/*    id="agent"*/}
                                        {/*    hasSelectAll={false}*/}
                                        {/*    disableSearch={true}*/}
                                        {/*    closeOnChangedValue={true}*/}
                                        {/*    multiple={false}*/}
                                        {/*    value={selectedAgents.length > 0 ? selectedAgents : []}*/}
                                        {/*    options={() => {*/}
                                        {/*        if (whiseAgents.length > 0) {*/}
                                        {/*            return whiseAgents.map((item, index) => {*/}
                                        {/*                return { label: item.name, value: item.id, agentDetail: item }*/}
                                        {/*            })*/}
                                        {/*        }*/}
                                        {/*        else {*/}
                                        {/*            return []*/}
                                        {/*        }*/}
                                        {/*    }}*/}
                                        {/*    onChange={changeHandlerAgentFilter}*/}
                                        {/*    labelledBy="Select an option"*/}
                                        {/*/>*/}
                                    </div>
                                </div>
                                <div className="col-md-4 col-12">
                                    <div className="form-group">
                                        <label className="form-group-label mt-0" htmlFor="status">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownStatusLbl"] : "Status"}</label>
                                        <MultiSelect
                                            id="transactionType"
                                            value={selectedStatuses.length > 0 ? selectedStatuses : []}
                                            options={() => {
                                                return [
                                                    { label: reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownStatusOptionFreeSl"] : "Free Slot", value: "1", _freeSlotIds: freeSlotIds },
                                                    { label: reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownStatusOptionToBeConfirm"] : "To be Confirmed", value: "2", beforeConfirmationIds: tobeConfirmedIds },
                                                    { label: reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownStatusOptionConfirmed"] : "Confirmed", value: "3", afterConfirmationIds: confirmedIds }
                                                ]
                                            }}
                                            onChange={handleChangeStatus}
                                            labelledBy="Select an option"
                                            overrideStrings={customMultiSelectLabels}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 text-end">
                                    <button className="site-btn-transparent" onClick={handleCancelFilter}>{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownsCancelBtn"] : "Cancel"}</button>
                                    <button className="site-btn ms-3" onClick={handlerSaveFilter}>{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownsSaveBtn"] : "Save"}</button>
                                </div>
                            </div>
                        </div>
                        <div>
                            <Schedular showMessageBox={showMessage} selectedProperty={selectedProperty} calendarRef={calendarRef} calendarEvents={whiseCalendarEvents} tobeConfirmedIds={tobeConfirmedIds}
                                confirmedIds={confirmedIds} freeSlotIds={freeSlotIds} eventClickHandler={clickHandlerEventPreview} selectedAgentsList={selectedAgents} selectedStatusAction={selectedStatuses}
                                showCalendarLoader={showCalendarLoader} getWhiseCalenderEvents={getWhiseCalenderEvents} setShowCalendarLoader={setShowCalendarLoader} currentRange={currentRange}
                                toLocalISOString={toLocalISOString} setEstateListContainEvent={setEstateListContainEvent} setEstateIdsHavingFreeSlotsInFutureOrPast={setEstateIdsHavingFreeSlotsInFutureOrPast}
                                showSynchingLoader={showSynchingLoader}
                            />
                        </div>
                    </div>
                    <div className={`${isPropertiesCollapsed == true ? "col-sm-1 pe-0" : "col-12 col-sm-4 col-md-3 col-lg-3 col-xl-3"}`} ref={container}>
                        <div className={`props-list d-flex align-items-center justify-content-between pb-3 ${isPropertiesCollapsed == true && "invisible overflow-hidden"}`}>
                            <span className="form-title">
                                {reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListTitle"] : "Properties"} ({filteredEstates.length})
                            </span>
                            <img src={collapseIcon} onClick={handlerCollapseProperties} />
                        </div>
                        <div className={`${isPropertiesCollapsed == true ? "" : "d-flex flex-row-reverse align-items-center justify-content-between mb-2"}`}>
                            <Dropdown>
                                <Dropdown.Toggle className={`filter-btn filter-btn-estates ${isPropertiesCollapsed == true ? "filter-caret mb-2" : ""}`} id="propertyFilter">
                                    <img src={filterIcon} className="pe-2" />
                                    {
                                        isPropertiesCollapsed == true && (purposeStatusId != "" || displayStatusIds.length > 0 || selectOffice != "") ? "" :
                                            <span className="pe-2">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterBtn"] : "Filter"}</span>
                                    }
                                    {
                                        purposeStatusId != "" || displayStatusIds.length > 0 || selectOffice != "" ?
                                            isPropertiesCollapsed == true ?
                                                <img src={filterCross} className="me-2" onClick={handlerClearEstateFilter} />
                                                :
                                                <button className="clear-btn" onClick={handlerClearEstateFilter}>
                                                    {reduxLanguageTranslations ? reduxLanguageTranslations["clearFilterButtonLabel"] : "Clear"}
                                                    <img src={whiteCross} />
                                                </button>
                                            //<img src={clearCross} className="me-1" onClick={handlerClearEstateFilter} />
                                            :
                                            ""
                                    }
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="estate-filter-dd">
                                    <div className="form-group">
                                        <label className="form-group-label mt-0">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageOfficeLbl"] : "Office"}</label>
                                        <select className="form-select filter-select mb-2" id="officeList" value={selectOffice} onChange={changehandlerSelectOfficeFilter}>
                                            <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageSelectOfficeOption"] : "Select Office"}</option>
                                            {
                                                officeList.length > 0 ? officeList.map((item, index) => {
                                                    return (
                                                        <option value={item.Id} key={index}>{item.Name}</option>
                                                    )
                                                })
                                                    :
                                                    <></>
                                            }
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label className="form-group-label mt-0">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterStatusLbl"] : "Purpose Status"}</label>
                                        <select className="form-select filter-select mb-2" value={purposeStatusId} onChange={changeHandlerPurposeStatusFilter}>
                                            <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterStatusOptionSelect"] : "Select Purpose Status"}</option>
                                            <option value="1">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterStatusSale"] : "For sale"}</option>
                                            <option value="2">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterStatusRent"] : "For rent"}</option>
                                            <option value="3">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterStatusAnnuitySale"] : "Life annuity sale"}</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label className="form-group-label mt-0">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterDisplayStatusLbl"] : "Display Status"}</label>
                                        {/*<select className="form-select filter-select" value={displayStatusId} onChange={changeHandlerDisplayStatusFilter}>
                                            <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterDisplayStatusSelect"] : "Select Display Status"}</option>
                                            <option value="1">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterDisplayStatusOffline"] : "Offline"}</option>
                                            <option value="2">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterDisplayStatusOnline"] : "Online"}</option>
                                            <option value="3">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterDisplayStatusMonth"] : "EstateOfTheMonth"}</option>
                                            <option value="4">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterDisplayStatusRealisations"] : "Realisations"}</option>
                                            <option value="5">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterDisplayStatusWebsite"] : "OnlineWebsiteOnly"}</option>
                                        </select>*/}
                                        <MultiSelect
                                            id="displayStatusId"
                                            value={displayStatusIds.length > 0 ? displayStatusIds : []}
                                            options={displayStatusOptions}
                                            onChange={changeHandlerDisplayStatusFilter}
                                            labelledBy="Select Display Status"
                                            className="filter-select"
                                            overrideStrings={customMultiSelectLabels}
                                        />
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                            <div className={`position-relative ${isPropertiesCollapsed == true ? "mb-2" : "me-2"}`}>
                                <input type="search" className="form-control search-box" placeholder={reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListPlaceHolderEstate"] : "Search by estate Id"} value={estateId} onChange={changeHandlerSearchByEstateId} />
                                <FontAwesomeIcon icon={faMagnifyingGlass} className={`search-icon`} />
                            </div>
                        </div>
                        <div className="position-relative mb-2">
                            <input type="search" className="form-control search-box me-2" placeholder={reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListPlaceHolderStreetNo"] : "Search by street, number, city, zip or price"} value={estateSearch} onChange={changeHandlerSearchByEstateProps} />
                            <FontAwesomeIcon icon={faMagnifyingGlass} className="search-icon" />
                        </div>
                        <div className={`${isPropertiesCollapsed == true ? "form-container form-container-collapsed" : "prop-container"}`} style={{ height: `${isPropertiesCollapsed == true ? "auto" : "83.5vh"}` }}>
                            <img src={expandIcon} className={`${isPropertiesCollapsed == true ? "d-block m-auto mb-3" : "d-none"}`} onClick={handlerCollapseProperties} />
                            <div className={`${isPropertiesCollapsed == true ? "collapsed-properties-scroll" : ""}`} style={{ height: `${isPropertiesCollapsed == true ? "83.5vh" : "auto"}` }}>

                                <div className={`p-3 text-center ${showPropertiesLoader ? "" : "d-none"}`}>
                                    <img src={calLoader} className={`cal-loader`} />
                                </div>
                                {
                                    filteredEstates.length > 0 ? filteredEstates.map((item, index) => {

                                        const isFound = selectedProperty != null && selectedProperty.id != undefined && item.id == selectedProperty.id ? true : false;

                                        var selectedClass = isFound == true ? "selected" : "";

                                        let isFreeSlotExistForEstate = false;
                                        let isEstateFutureOrPastFreeSlot = false;
                                        let isConfigsSaved = false;

                                        let isActivatedInDb = activatedEstates.includes(item.id);
                                        let isSuspended = suspendedEstates.includes(item.id);

                                        if (estateIdsHavingConfiguration.length > 0 && estateIdsHavingConfiguration.includes(item.id)) {
                                            isConfigsSaved = true;
                                        }

                                        if (estateListContainEvent.length > 0) {
                                            isFreeSlotExistForEstate = estateListContainEvent.indexOf(item.id) >= 0 ? true : false;
                                        }

                                        if (estateIdsHavingFreeSlotsInFutureOrPast.length > 0) {
                                            isEstateFutureOrPastFreeSlot = estateIdsHavingFreeSlotsInFutureOrPast.indexOf(item.id) >= 0 ? true : false;
                                        }

                                        if (isPropertiesCollapsed == true) {
                                            let propertyImage = placeholderSmall;
                                            if (item.pictures != undefined && item.pictures.length > 0) {
                                                propertyImage = item.pictures[0].urlSmall;
                                            }
                                            return (
                                                <OverlayTrigger key={index} delay={{ hide: 0, show: 300 }} trigger="click" rootClose placement="left" x-placement="left"
                                                    overlay={(props) => (
                                                        <Tooltip className="prop-tooltip" {...props}>
                                                            <div className={`form-container position-relative form-container-expanded ${selectedClass}`}>
                                                                <div className="prop-img-container position-relative">
                                                                    {
                                                                        item.price != undefined ?
                                                                            <span className="price-tag">{formatPrice(item.price, item.currency)}</span>
                                                                            :
                                                                            ""
                                                                    }
                                                                    <a href={`${variables.Booking_URL}${item.id}/${clientId}/${item.officeId ? item.officeId : officeId}/${contactId}`} className={`btn-booking ${isFreeSlotExistForEstate == true ? "" : "d-none"}`} target="_blank">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListBookingLink"] : "Booking"}</a>
                                                                    <img src={propertyImage} className="property-img" />
                                                                    {
                                                                        isSuspended ?
                                                                            <span className="suspended-tag">Pending</span>
                                                                            :
                                                                        <></>
                                                                    }
                                                                </div>
                                                                <div className="property-name mt-3">
                                                                    <span>{item.name} ({item.id})</span>
                                                                    <span className="add-slot-link" onClick={handlerAddSlot}>
                                                                        <img src={plusBlueIcon} className="me-2" /> {reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListAddSlotBtn"] : "Add Slot"}
                                                                    </span>
                                                                </div>

                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <div className="prop-address my-2">
                                                                        {/*<img src={locationPin} className="me-2" />*/}
                                                                        <p className="mb-0">
                                                                            {
                                                                                (item.address == undefined ? "" : item.address) + " " +
                                                                                (item.number == undefined ? "" : item.number) + ""
                                                                            }
                                                                        </p>
                                                                        <p className="mb-0">
                                                                            {
                                                                                (item.zip == undefined ? "" : item.zip) + " " +
                                                                                (item.city == undefined ? "" : item.city)
                                                                            }
                                                                        </p>
                                                                    </div>
                                                                    <Dropdown className="estate-drop-menu" show={openDropdownId === item.id} onClick={(e) => handleDropdownToggle(e, item.id, item)}>
                                                                        <Dropdown.Toggle className="estate-toggle-menu" variant="light" id={`dropdown-basic${item.id}`}>
                                                                            <FontAwesomeIcon icon={faEllipsisVertical} className="color-blue" />
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu className="text-center p-0">
                                                                            {
                                                                                isActivatedInDb ?
                                                                                    <button className={`drop-menu-btn text-start`} onClick={(e) => markEstateDeactiveInDB(item)}>{reduxLanguageTranslations ? reduxLanguageTranslations["deactivateEstateInDatabase"] : "Deactivate"}</button>
                                                                                    :
                                                                                    <button className={`drop-menu-btn text-start`} onClick={(e) => markEstateActiveInDB(item)}>{reduxLanguageTranslations ? reduxLanguageTranslations["activateEstateInDatabase"] : "Activate"}</button>
                                                                            }
                                                                            <hr className={`mx-2 my-0 ${isFreeSlotExistForEstate || isEstateFutureOrPastFreeSlot || isConfigsSaved ? "" : "d-none"}`} />
                                                                            <button className={`drop-menu-btn text-start ${isFreeSlotExistForEstate == true ? "" : "d-none"}`} onClick={() => copToClipBoard(`${variables.Booking_URL}${item.id}/${clientId}/${item.officeId ? item.officeId : officeId}/${contactId}`)}>{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListCopyLink"] : "Copy booking link"}</button>
                                                                            <hr className={`mx-2 my-0 ${isFreeSlotExistForEstate == true ? "" : "d-none"}`} />
                                                                            <button className={`drop-menu-btn text-start ${isEstateFutureOrPastFreeSlot ? "" : "d-none"}`} onClick={(e) => handleDeleteAllFreeSlotsClick(e, item.id)}>{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListDeleteFreeSlot"] : "Delete all free slots"}</button>
                                                                            <hr className={`mx-2 my-0 ${isEstateFutureOrPastFreeSlot && isConfigsSaved ? "" : "d-none"}`} />
                                                                            <button className={`drop-menu-btn text-start ${isConfigsSaved == true ? "" : "d-none"}`}
                                                                                onClick={(e) => editEstateConfigurations(e, item.id)}>
                                                                                {reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListEditForm"] : "Edit Form"}
                                                                            </button>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </div>
                                                                <div className="row prop-detail-row mt-3">
                                                                    <div className="col-4 d-flex align-items-center justify-content-center border-end">
                                                                        <img src={bedIcon} className={`${item.bedRooms != undefined ? "me-1" : ""}`} />
                                                                        <span className="smallImgIcon-Modal-info">
                                                                            {
                                                                                item.bedRooms != undefined ?
                                                                                    item.bedRooms
                                                                                    :
                                                                                    <></>
                                                                            }
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-4 d-flex align-items-center justify-content-center border-end">
                                                                        <img src={showerIcon} className={`${item.bathRooms != undefined ? "me-1" : ""}`} />
                                                                        <span className="smallImgIcon-Modal-info">
                                                                            {
                                                                                item.bathRooms != undefined ?
                                                                                    item.bathRooms
                                                                                    :
                                                                                    <></>
                                                                            }
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-4 d-flex align-items-center justify-content-center">
                                                                        <img src={liftIcon} className={`${item.area != undefined ? "me-1" : ""}`} />
                                                                        {
                                                                            item.area != undefined ?
                                                                                <span className="smallImgIcon-Modal-info">{item.area}<span className="ms-05">m</span><sup>2</sup></span>
                                                                                :
                                                                                <></>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Tooltip>
                                                    )}>
                                                    <div className={`mb-3 overflow-hidden ${selectedClass}`} onClick={(e) => handlerPropertyClick(item)} id={item.id}>
                                                        <img src={propertyImage} className="sm-prop-img" />
                                                    </div>
                                                </OverlayTrigger>
                                            )
                                        }
                                        else {
                                            let propertyImage = placeholderLarge;
                                            if (item.pictures != undefined && item.pictures.length > 0) {
                                                propertyImage = item.pictures[0].urlLarge;
                                            }
                                            return (
                                                <div className={`form-container position-relative form-container-expanded expanded-estates mb-3 ${selectedClass}`} key={index} onClick={(e) => handlerPropertyClick(item)}>
                                                    <div className="prop-img-container position-relative">
                                                        {
                                                            item.price != undefined ?
                                                                <span className="price-tag">{formatPrice(item.price, item.currency)}</span>
                                                                :
                                                                ""
                                                        }
                                                        <a href={`${variables.Booking_URL}${item.id}/${clientId}/${item.officeId ? item.officeId : officeId}/${contactId}`} className={`btn-booking ${isFreeSlotExistForEstate == true ? "" : "d-none"}`} target="_blank">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListBookingLink"] : "Booking"}</a>
                                                        <img src={propertyImage} className="property-img" />
                                                        {
                                                            isSuspended ?
                                                                <span className="suspended-tag">Pending</span>
                                                                :
                                                                <></>
                                                        }
                                                    </div>
                                                    <div className="property-name mt-3">
                                                        <span>{item.name} ({item.id})</span>
                                                        <span className="add-slot-link" onClick={handlerAddSlot}>
                                                            <img src={plusBlueIcon} className="me-2" /> {reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListAddSlotBtn"] : "Add Slot"}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <div className="prop-address my-2">
                                                            {/*<img src={locationPin} className="me-2" />*/}
                                                            <p className="mb-0">
                                                                {
                                                                    (item.address == undefined ? "" : item.address) + " " +
                                                                    (item.number == undefined ? "" : item.number) + ""
                                                                }
                                                            </p>
                                                            <p className="mb-0">
                                                                {
                                                                    (item.zip == undefined ? "" : item.zip) + " " +
                                                                    (item.city == undefined ? "" : item.city)
                                                                }
                                                            </p>
                                                        </div>
                                                        <Dropdown className="estate-drop-menu" show={openDropdownId === item.id} onClick={(e) => handleDropdownToggle(e, item.id, item)}>
                                                            <Dropdown.Toggle className="estate-toggle-menu" variant="light" id="dropdown-basic">
                                                                <FontAwesomeIcon icon={faEllipsisVertical} className="color-blue" />
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu className="text-center p-0">
                                                                {
                                                                    isActivatedInDb ?
                                                                        <button className={`drop-menu-btn text-start`} onClick={(e) => markEstateDeactiveInDB(item)}>{reduxLanguageTranslations ? reduxLanguageTranslations["deactivateEstateInDatabase"] : "Deactivate"}</button>
                                                                        :
                                                                        <button className={`drop-menu-btn text-start`} onClick={(e) => markEstateActiveInDB(item)}>{reduxLanguageTranslations ? reduxLanguageTranslations["activateEstateInDatabase"] : "Activate"}</button>
                                                                }
                                                                <hr className={`mx-2 my-0 ${isFreeSlotExistForEstate || isEstateFutureOrPastFreeSlot || isConfigsSaved ? "" : "d-none"}`} />
                                                                <button className={`drop-menu-btn text-start ${isFreeSlotExistForEstate == true ? "" : "d-none"}`} onClick={() => copToClipBoard(`${variables.Booking_URL}${item.id}/${clientId}/${item.officeId ? item.officeId : officeId}/${contactId}`)}>{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListCopyLink"] : "Copy booking link"}</button>
                                                                <hr className={`mx-2 my-0 ${isFreeSlotExistForEstate == true ? "" : "d-none"}`} />
                                                                <button className={`drop-menu-btn text-start ${isEstateFutureOrPastFreeSlot ? "" : "d-none"}`} onClick={(e) => handleDeleteAllFreeSlotsClick(e, item.id)}>{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListDeleteFreeSlot"] : "Delete all free slots"}</button>
                                                                <hr className={`mx-2 my-0 ${isEstateFutureOrPastFreeSlot && isConfigsSaved ? "" : "d-none"}`} />
                                                                <button className={`drop-menu-btn text-start ${isConfigsSaved == true ? "" : "d-none"}`}
                                                                    onClick={(e) => editEstateConfigurations(e, item.id)}>
                                                                    {reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListEditForm"] : "Edit Form"}
                                                                </button>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                    <div className="row prop-detail-row mt-3">
                                                        <div className="col-4 d-flex align-items-center justify-content-center border-end">
                                                            <img src={bedIcon} className={`${item.bedRooms != undefined ? "me-1" : ""}`} />
                                                            <span className="smallImgIcon-Modal-info">
                                                                {
                                                                    item.bedRooms != undefined ?
                                                                        item.bedRooms
                                                                        :
                                                                        <></>
                                                                }
                                                            </span>
                                                        </div>
                                                        <div className="col-4 d-flex align-items-center justify-content-center border-end">
                                                            <img src={showerIcon} className={`${item.bathRooms != undefined ? "me-1" : ""}`} />
                                                            <span className="smallImgIcon-Modal-info">
                                                                {
                                                                    item.bathRooms != undefined ?
                                                                        item.bathRooms
                                                                        :
                                                                        <></>
                                                                }
                                                            </span>
                                                        </div>
                                                        <div className="col-4 d-flex align-items-center justify-content-center">
                                                            <img src={liftIcon} className={`${item.area != undefined ? "me-1" : ""}`} />
                                                            {
                                                                item.area != undefined ?
                                                                    <span className="smallImgIcon-Modal-info">{item.area}<span className="ms-05">m</span><sup>2</sup></span>
                                                                    :
                                                                    <></>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    })
                                        :
                                        <></>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ConfirmDeleteWindow showConfirmWindow={showConfirmWindow} handleConfirmWindowClose={handleConfirmWindowClose} callBackConfirmDeleteFreeSlots={callBackConfirmDeleteFreeSlots} displayMessage={confirmWindowMessage} />
            <EventModal showModal={showModal} handleCloseModal={handleClose} showMessage={showMessage} whiseAgents={whiseAgents} saveNewWhiseEvent={saveNewWhiseEvent}
                preview={previewEvent} callBackToUpdateCalendarFilter={callBackToUpdateCalendarFilter} previewEventDetail={previewEventDetail}
                tobeConfirmedIds={tobeConfirmedIds} confirmedIds={confirmedIds} freeSlotIds={freeSlotIds} deleteWhiseCalendarEvent={deleteWhiseCalendarEvent}
                acceptToBeConfirmedEvents={acceptToBeConfirmedEvents} isEstateConfigurationsEdit={isEstateConfigurationsEdit} getEstateIdsHavingConfigSaved={getEstateIdsHavingConfigSaved}
                setIsLocalDbEventToBeDeleted={setIsLocalDbEventToBeDeleted} officeSettings={officeSettings}
            />
        </>
    )
}